import { i18n } from '@/services/i18n';
import {
    BaseFilterNames, CodeOKRB,
    CodeSalesPointDto,
    DataRange,
    FindFiltersParams,
    GlobalSettingsData,
    TradingSettingsData,
    Hints, MarketWithSalePoints,
    MinRetailPrice,
    PriceCorridor,
    PromoFilesFilterParams,
    ScenarioNameWithFilters,
    ScenariosWithFilters,
    SelectKviCart,
    SelectMarket, AdvancedFilterNames
} from '@/interfaces/global-data';
import {
    AdditionalRole,
    AllDetailReportFilterNames,
    AllEventFiltersForTable,
    AllFiltersForRulesTable,
    AllPreCalcFilterNamesForTable,
    AllScheduleFiltersForTable,
    AppliedFiltersData,
    AssortmentDirectoryFilterOptions,
    AssortmentDirectoryFilterOptionsParams,
    AssortmentDirectoryItem,
    AssortmentDirectoryParams,
    BaseFilter,
    BaseFilterRoundingRules,
    BaseFilterRoundingTable,
    CalcBySelectedSKUsParams,
    CalcFilters,
    CalcIndividualConfigMap,
    CalcParams,
    ChangePassword,
    CompetitorNameAndFilter,
    CompetitorsPriceFilter,
    CompetitorsPricesView,
    Config,
    DetailReportsPricesAndCodes,
    EventFilter,
    EventIndividualConfigs,
    EventsAddCalcParams,
    EventsCalcParams,
    EventsListItem,
    EventsListProductItem,
    EventsListQuery,
    EventsParameters,
    FilesPageParams,
    FileType,
    FiltersWithCheckSum,
    FixedPriceItem,
    FixedPriceParams,
    FoundEntityEvent,
    FtpParameters,
    FtpSettings,
    FtpUsersAndTradings,
    GetTaskInfo,
    ICallGrabbingDTO,
    IdAndName,
    IGrabbingConfigDTO,
    IndividualConfigCmd,
    ISaveGrabbingConfigDTO,
    KviCartFilters,
    KviCartPackageConfig, LastAssortmentUpdatingStatus, DirectoriesSynchronizationStatus,
    OKRBCodeConfig,
    OKRBCodesConfig,
    PackageCalcConfig,
    PackageKviRecommendsConfig,
    PackageParamsInDetailReportFilters,
    PackagePromoConfig,
    PackageTasksCount,
    Page,
    PageParams,
    ParametersListQuery,
    ParametersListFilterData,
    ParamsListItem,
    PreCalcColumns,
    PreCalcFilters,
    PreCalcIndividualConfigs,
    PreCalcStartSettings,
    ProductInfo,
    ProductSegmentIdAndName,
    ProductTag,
    PromoFilesSkuNameAndInternalCode,
    PromoFilters,
    PromoIndividualConfigMap,
    SaleIndividualConfigMap,
    PromoSku,
    RegularCompetitorsPricesView,
    ReportDetailColumnsForAddOrDelete,
    ReportDetailFieldsView,
    ReportDetailParams,
    ReportDetailSegments,
    RequestEventList,
    ResultTableDetailReports,
    ResultTableDetails,
    SalesMonitorResultTableDetails,
    ResultTableHeaders,
    RevaluationFtpParams,
    RevaluationQueueFilters,
    RevaluationQueueItem,
    RevaluationQueueListRequestParams,
    RevaluationQuotasOfTradingNetwork,
    RevaluationQuotasToSave,
    RevaluationQuotesData,
    RoundingRulesFilter,
    SalePointsDirectoryFilterOptions,
    SalePointsDirectoryItem,
    SalePointsDirectoryParams,
    ImportUploadOption,
    SalesCalculationFilters,
    PromotionsCalculationFilters,
    SalesFilters,
    ScheduleCalcColumns,
    ScheduleCalcFilter,
    ScheduleIndividualConfigs,
    Segment,
    ServerFile,
    SetUserTradingNetworkTreeItem,
    Sku,
    SkuCharacteristicsKeysAndAttributes,
    SkuFilter,
    SmallEventFilter,
    SmallPreCalcListFilter,
    SmallScheduleListFilter,
    TaskData,
    TaskIdToInternalCode,
    getTaskInfoFilterTypeLabel,
    TaskNoteDTO,
    TaskParams,
    TaskType,
    TradingAndMoney, UpdateActiveStatusParams,
    UpdatedByUserInfo,
    User,
    UserForm,
    UserPermissions,
    UserShortInfo,
    UserTradingNetworkTreeItem,
    IStoreLegalEntityTableParams,
    IStoreLegalEntityTableItem,
    EventsProcessingStatus,
    AssortmentDateRequest,
    ICompetitorPricesFilterOptions,
    KviCartConflictingItemDto,
    ICheckboxesStateWithFilter,
    IHttpUnlinkCompetitorProductsFilter,
    IPaginationAndSortingData,
    SaleIndividualConfigFieldsToSave,
    KviRoundingRulesFilter,
    KviRoundingParams,
    KviRoundingFindParams,
    ManuallyEventsWatchingParams,
    IExportTask,
    ITokenForDownloadExportFile,
    IGetReportDetailFieldsByUserIdParams,
    IHttpGetFixedPricesFilterOptions,
    IFetchAssortmentFilterOptionsParams,
    IHttpFetchAssortmentFilterOptions,
    SmallSalesReportsScheduleListFilter,
    BaseFilterOptions,
    EventEditData,
    SaveModuleItemParamsFilter,
    ModuleItemFilters,
    ModuleItemIndividualConfigFieldsToSave,
    ICompetitorProduct,
    CompetitorsPriceMethods,
    CompetitorsPriceStrategies,
    ProductLineRecommendationSearchParams,
    ProductLineRecommendationSearchStatusId,
    FetchResultsFilterParams,
    StartPriceAuditRequest,
    ParsingResultTableItem,
    TaskHeadersAndKeyIndicatorsParams,
    CartProductsTableFilterOptionsPayloadFilters,
    ApproveReportElementsSelectedCheckboxesData,
    UniqSkuData,
    PriceImportMode,
    IUpdateOmnichannelStrategiesTask
} from '@/interfaces/server-data';
import '@/axio-plugin';
import toast from '@/mixins/toast';
import {AxiosPromise, AxiosResponse} from 'axios';
import {Component, Mixins} from 'vue-property-decorator';
import { CreateAggregatedReportPayloadParams, IidAndName, ISalesBasicFilters } from "@/pages/Sales/data";
import {
    CreateAggregatedPromotionsReportPayloadParams,
    CreateAggregatedModuleReportPayloadParams,
    CategoryFindFiltersPayload,
    CategoryParamsValues,
    IModuleItemDeleteProductsFilter,
    TModuleType,
} from "@/pages/ModuleItems/data";

@Component
export default class Http extends Mixins(toast) {

  httpSaveOrDeleteKviParam(filter: CalcFilters): AxiosPromise<string> {
    return this.$http.post('/api/products/addOrDeleteKviParam', filter);
  }

  httpSaveOrDeleteKviParamForNewProducts(filter: CalcFilters): AxiosPromise<string> {
    return this.$http.post('/api/products/addOrDeleteKviParamForNewProducts', filter);
  }

  httpPostAddTask(filter: CalcFilters): AxiosPromise<string> {
    return this.$http.post('/api/task/add', filter);
  }

  httpPostAddPackageKviCartTask(filter: KviCartPackageConfig): AxiosPromise<string> {
    return this.$http.post('/api/task/packageKviCart', filter);
  }

  httpPostSearchKviRecommends(filter: CalcFilters): AxiosPromise<string> {
    return this.$http.post('/api/task/kviSearch', filter);
  }

  httpPostPriceCorridor(filter: CalcFilters): AxiosPromise<PriceCorridor> {
    return this.$http.post('/api/task/priceCorridor', filter);
  }

  httpPostDataRange(filter: CalcFilters): AxiosPromise<DataRange> {
    return this.$http.post('/api/task/dataRange', filter);
  }

  httpGetProductInfo(params: GetTaskInfo): AxiosPromise<ProductInfo> {
    return this.$http.post('/api/task/info', params, { params: { userId: 1 } })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadDataWithParam', { param0: getTaskInfoFilterTypeLabel(params.type) }) as string);
          throw e;
        });
  }

    httpStartGeneratingReport(taskId: number): Promise<any> {
        return this.$http.post('/api/task/result/generate', null, {params: {taskId}})
            .then((r) => {
                this.showInfo(r.data ? r.data : i18n.t('http.errors.reportGenerationStarted') as string)
            })
            .catch((e) => {
                this.showError(i18n.t('http.errors.startReportGeneration', { param0: e.message }) as string)
                throw e
            });
    }

    httpStartGeneratingRTNReport(taskId: number): Promise<any> {
        return this.$http.post('/api/task/result/generate-rtn', null, {params: {taskId}})
            .then((r) => {
                this.showInfo(r.data ? r.data : i18n.t('http.errors.reportGenerationStarted2') as string)
            })
            .catch((e) => {
                this.showError(i18n.t('http.errors.startReportGeneration2', { param0: e.message }) as string)
                throw e
            });
    }

    httpGetLicenseExpirationWarning(): Promise<any> {
        return this.$http.get('/api/license/expiration-warning')
            .catch((e) => {
                this.showError(this.$t('shared.messages.licenseExpirationGetError', { message: e.message }) as string)
                throw e
            });
    }

  httpGetUpdatedByUserInfo(tradingId: number): AxiosPromise<UpdatedByUserInfo> {
    return this.$http.get('/api/filters/updatedBy', { params: {tradingId} })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadUsers') as string);
          throw  e
        });
  }

  httpGetBaseFilterOptions(tradingId: number, appliedFilters?: AppliedFiltersData): AxiosPromise<BaseFilterOptions> {
    return this.$http.post('/api/filters/rules-list/options', appliedFilters, { params: { tradingId } })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadBaseFilterOptions') as string);
          throw  e
        });
  }

  httpGetBaseFilterOptionsIndividual(tradingId: number, appliedFilters?: AppliedFiltersData): AxiosPromise<BaseFilterOptions> {
    return this.$http.post('/api/filters/rules-list/options/individual', appliedFilters, { params: { tradingId } })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadBaseFilterOptions2') as string);
          throw e;
        });
  }

  httpGetCompetitorsNames(tradingId: number, format: number | null = null, region: number[] | null = null, cluster: number | number[] | null = null): AxiosPromise<CompetitorNameAndFilter[]> {
    return this.$http.get('/api/competitors/names', {
      params: {
        tradingId: tradingId
      }
    })
      .catch((e) => {
        this.showError(i18n.t('http.errors.loadCompetitorOptions') as string);
        throw  e
      });
  }

  httpGetSkuList(filter: SkuFilter, skuListLimit: number, nextSkuListOffset: number): AxiosPromise<Page<Sku[]>> {
    return this.$http.post('/api/products/sku-list', filter, {
      params: {
        limit: skuListLimit,
        offset: nextSkuListOffset,
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadProducts') as string);
          throw  e
        });
  }

  httpHasMatchingFilterItems(filter: SkuFilter): AxiosPromise<boolean> {
      return this.$http.post('/api/assortment/kvi-cart-has-matching-filter-items', filter)
          .catch((e) => {
              this.showError(i18n.t('http.errors.checkCartProducts') as string);
              throw  e
          });
  }

  httpGetKviCartSkuList(filter: SkuFilter, skuListLimit: number, nextSkuListOffset: number, isSales?: boolean): AxiosPromise<Page<Sku[]>> {
    return this.$http.post('/api/assortment/kviCartsSkuList', filter, {
      params: {
        limit: skuListLimit,
        offset: nextSkuListOffset,
        ...(isSales ? {isSales: true} : {})
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadProducts2') as string);
          throw  e
        });
  }

  httpGetNewProductsKviCartList(filter: SkuFilter, newProductsListLimit: number, nextNewProductsListOffset: number): AxiosPromise<Page<Sku[]>> {
    return this.$http.post('/api/assortment/kviCartNewProductsList', filter, {
      params: {
        limit: newProductsListLimit,
        offset: nextNewProductsListOffset,
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadNewProducts') as string);
          throw  e
        });
  }

  httpGetProductRangeListByFilters(filter: SkuFilter): AxiosPromise<string[]> {
    return this.$http.post('/api/products/getProductRangeListByFilters', filter)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadProductRanges') as string);
          throw  e
        });
  }

  httpGetPromoFilesByFilters(filter: SkuFilter): AxiosPromise<PromoFilesSkuNameAndInternalCode[]> {
    return this.$http.post('/api/products/promo-files', filter)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadPromoProducts') as string);
          throw  e
        });
  }

  httpGetAllSku(filters: SkuFilter): AxiosPromise<Sku[]> {
    return this.$http.post('/api/products/getAllSku', filters)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadProducts3') as string);
          throw  e
        });
  }

  httpGetKviCartAllSku(filters: SkuFilter): AxiosPromise<Sku[]> {
    return this.$http.post('/api/assortment/getKviCartAllSku', filters)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadProducts4') as string);
          throw  e
        });
  }

  httpGetAllNewProducts(filters: SkuFilter): AxiosPromise<Sku[]> {
    return this.$http.post('/api/products/getAllNewProducts', filters)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadNewProductsError') as string);
          throw  e
        });
  }

  httpGetNewProductsList(filter: SkuFilter, newProductsListLimit: number, nextNewProductsListOffset: number): AxiosPromise<Page<Sku[]>> {
    return this.$http.post('/api/products/newProductsList', filter, {
      params: {
        limit: newProductsListLimit,
        offset: nextNewProductsListOffset,
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadNewProducts2') as string);
          throw  e
        });
  }

  httpFindTaskByParams(data: CalcFilters): AxiosPromise<TaskData> {
    return this.$http.post('/api/task/findTask', data)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadResultsData') as string);
          throw  e
        });
  }

  httpGetResultTableHeaders(taskId: number): AxiosPromise<ResultTableHeaders[]> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.get(`/api/task/tableHeaders/${taskId}`, { params: {userId} })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadResultsData2') as string);
          throw  e
        });
  }

  getAllTasksKeyIndicators(payload: TaskHeadersAndKeyIndicatorsParams): AxiosPromise<ResultTableHeaders[]> {
    return this.$http.post(`/api/task/getAllTasksKeyIndicators`, payload)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadResultsData3') as string);

          throw e;
        });
  }

  httpGetAllUserTasksHeaders(params: TaskHeadersAndKeyIndicatorsParams): AxiosPromise<ResultTableDetails> {
    // Преобразование массивов в строки, если они не равны null
    const categoriesStr = params.categories && params.categories.length ? params.categories.join(',') : null;
    const groupsOfProductStr = params.groupsOfProduct && params.groupsOfProduct.length ? params.groupsOfProduct.join(',') : null;
    const subcategoriesStr = params.subcategories && params.subcategories.length ? params.subcategories.join(',') : null;
    const storeFormatStr = params.storeFormat && params.storeFormat.length ? params.storeFormat.join(',') : null;
    const storeRegionValuesStr = params.storeRegionValues && params.storeRegionValues.length ? params.storeRegionValues.join(',') : null;
    const storeClusterStr = params.storeCluster && params.storeCluster.length ? params.storeCluster.join(',') : null;
    const storeSegmentStr = params.storeSegment && params.storeSegment.length ? params.storeSegment.join(',') : null;

    return this.$http.get(`/api/task/getAllUserTasksHeaders`, {
      params: {
        limit: params.limit,
        offset: params.offset,
        tradingId: params.tradingId,
        categories: categoriesStr,
        groupsOfProduct: groupsOfProductStr,
        subcategories: subcategoriesStr,
        storeFormat: storeFormatStr,
        storeRegionValues: storeRegionValuesStr,
        storeCluster: storeClusterStr,
        categoryStrategy: params.categoryStrategy,
        separateSubcategories: params.separateSubcategories,
        separateClusters: params.separateClusters,
        storeSegment: storeSegmentStr,
        timeout: params.timeout,
        priority: params.priority,
        dateBefore: params.dateBefore,
        dateAfter: params.dateAfter,
        status: params.status,
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadBatchReports') as string);
          throw e;
        });
  }

  httpGetSaleAllUserTasksHeaders(params: TaskHeadersAndKeyIndicatorsParams): AxiosPromise<SalesMonitorResultTableDetails> {
      return this.$http.get(`/api/task/getAllUserTasksHeaders`, {
          params: {
              limit: params.limit,
              offset: params.offset,
              tradingId: params.tradingId,
              categories: params.categories && params.categories.length ? params.categories.join(',') : null,
              groupsOfProduct: params.groupsOfProduct && params.groupsOfProduct.length ? params.groupsOfProduct.join(',') : null,
              subcategories: params.subcategories && params.subcategories.length ? params.subcategories.join(',') : null,
              storeFormat: params.storeFormat && params.storeFormat.length ? params.storeFormat.join(',') : null,
              storeRegionValues: params.storeRegionValues && params.storeRegionValues.length ? params.storeRegionValues.join(',') : null,
              storeCluster: params.storeCluster && params.storeCluster.length ? params.storeCluster.join(',') : null,
              dateBefore: params.dateBefore,
              dateAfter: params.dateAfter,
              status: params.status,
              types: params.types,
          },
          paramsSerializer: (params) => {
              const result = new URLSearchParams();

              Object.entries(params).forEach(([key, value]) => {
                  if (Array.isArray(value)) {
                      value.forEach(item => {
                          if (item !== null) {
                              result.append(key, item);
                          }
                      });
                  } else {
                      if (value !== null) {
                          result.append(key, String(value));
                      }
                  }
              });

              return result.toString();
          },
      })
          .catch((e) => {
              this.showError(i18n.t('http.errors.loadSaleReports') as string);
              throw e;
          });
  }

    httpGetModuleItemsAllUserTasksHeaders(params: TaskHeadersAndKeyIndicatorsParams): AxiosPromise<SalesMonitorResultTableDetails> {
        return this.$http.get(`/api/task/getAllUserTasksHeaders`, {
            params: {
                limit: params.limit,
                offset: params.offset,
                tradingId: params.tradingId,
                categories: params.categories && params.categories.length ? params.categories.join(',') : null,
                groupsOfProduct: params.groupsOfProduct && params.groupsOfProduct.length ? params.groupsOfProduct.join(',') : null,
                subcategories: params.subcategories && params.subcategories.length ? params.subcategories.join(',') : null,
                storeFormat: params.storeFormat && params.storeFormat.length ? params.storeFormat.join(',') : null,
                storeRegionValues: params.storeRegionValues && params.storeRegionValues.length ? params.storeRegionValues.join(',') : null,
                storeCluster: params.storeCluster && params.storeCluster.length ? params.storeCluster.join(',') : null,
                dateBefore: params.dateBefore,
                dateAfter: params.dateAfter,
                status: params.status,
                types: params.types,
            },
            paramsSerializer: (params) => {
                const result = new URLSearchParams();

                Object.entries(params).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        value.forEach(item => {
                            if (item !== null) {
                                result.append(key, item);
                            }
                        });
                    } else {
                        if (value !== null) {
                            result.append(key, String(value));
                        }
                    }
                });

                return result.toString();
            },
        })
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadSaleReports2') as string);
                throw e;
            });
    }

  httpGetAllNotAgreedUserTasksHeaders(userId: number, newLimit: number, newOffset: number): AxiosPromise<ResultTableHeaders[]> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id } = JSON.parse(auth);

    return this.$http.get(`/api/task/getAllNotAgreedUserTasksHeaders/${userId}`, {
      params: {
        limit: newLimit,
        offset: newOffset,
          userId: user_id
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadBatchReports2') as string);
          throw e
        });
  }

  httpGetAllRequireAttentionUserTasksHeaders(userId: number, newLimit: number, newOffset: number): AxiosPromise<ResultTableHeaders[]> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id } = JSON.parse(auth);

    return this.$http.get(`/api/task/getAllRequireAttentionUserTasksHeaders/${userId}`, {
      params: {
        limit: newLimit,
        offset: newOffset,
        userId: user_id,
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadBatchReports3') as string);
          throw e
        });
  }

  httpGetAllSubTasksGeneralPackageHeaders(taskId: number, limitParam: number = 25, offsetParam: number = 0): AxiosPromise<ResultTableHeaders[]> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.get(`/api/task/getAllSubTasksGeneralPackageHeaders/${taskId}`, {
      params: {limit: limitParam, offset: offsetParam, userId},
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadBatchReports4') as string);
          throw  e
        });
  }

  httpGetAllSubTasksGeneralPackageHeadersSize(taskId: number): AxiosPromise<number> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.get(`/api/task/getAllSubTasksGeneralPackageHeadersSize/${taskId}`, { params: {userId} })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadBatchReports5') as string);
          throw  e
        });
  }

  httpGetResultTableDetailReports(taskId: number, skuListLimit: number, nextSkuListOffset: number, data: ReportDetailParams, isNeedCheck: boolean = true): AxiosPromise<Page<ResultTableDetailReports[]>> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.post(`/api/task/tableDetailReports/${taskId}`, data, {
      params: {
        limit: skuListLimit,
        offset: nextSkuListOffset,
        isNeedCheck,
        userId,
      },
    }).catch((e) => {
      this.showError(i18n.t('http.errors.loadDetailedReport') as string);
      throw  e
    });
  }

  httpGetAllReportDetailIdsByFilters(taskId: number, params: ReportDetailParams): AxiosPromise<UniqSkuData[]> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.post(`/api/task/getAllReportDetailIdsByFilters/${taskId}`, params, { params: {userId} });
  }

  httpGetResultTableDetailsFilterNames(taskId: number, type: TaskType): AxiosPromise<AllDetailReportFilterNames> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.get(`/api/task/getAllDetailReportFilters/${taskId}`, {params: {taskType: type, userId }})
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadDetailedReportFilters') as string);
          throw  e
        });
  }

  httpGetSavedScheduleReports(smallFilter: SmallScheduleListFilter | SmallSalesReportsScheduleListFilter, scheduleListLimit: number, nextScheduleListOffset: number): AxiosPromise<Page<ScheduleCalcColumns[]>> {
    return this.$http.post('/api/scheduleCalc/list', smallFilter, {
      params: {
        limit: scheduleListLimit,
        offset: nextScheduleListOffset,
      },
    }).catch((e) => {
      this.showError(i18n.t('http.errors.loadSavedCharts') as string);
      throw  e
    });
  }

  httpGetSavedEvents(params: RequestEventList): AxiosPromise<Page<SmallEventFilter[]>> {
    return this.$http.get('/api/load-events', {
      params,
    }).catch((e) => {
      this.showError(i18n.t('http.errors.loadSavedEvents') as string);
      throw  e
    });
  }

  httpGetAllFiltersInScheduleReports(ids: number[]): AxiosPromise<AllScheduleFiltersForTable> {
    return this.$http.post('/api/scheduleCalc/getAllFilters', ids)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadChartTableFilters') as string);
          throw  e
        });
  }

  httpGetAllFiltersInEventList(currentTab: string): AxiosPromise<AllEventFiltersForTable> {
    return this.$http.post(`/api/load-events/getAllFilters?currentTab=${currentTab}`)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadEventTableFilters') as string);
          throw  e
        });
  }

  httpDeleteScheduleCalc(scheduleCalcId: number): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.delete(`/api/scheduleCalc/${scheduleCalcId}`, { params: { userId } });
  }

  httpDeleteEvent(eventId: number): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);
      return this.$http.delete(`/api/load-events/${eventId}`, { params: {userId} });
  }

  httpStartWatchingEventsSimpleManually(params: ManuallyEventsWatchingParams): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      return this.$http.post('/api/load-events/watching/start-simple', params)
          .catch((e) => {
              this.showError(i18n.t('http.errors.startEventScanning') as string);
              throw  e
          })
  }

  httpStartWatchingEventsKviManually(params: ManuallyEventsWatchingParams): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      return this.$http.post('/api/load-events/watching/start-kvi', params)
          .catch((e) => {
              this.showError(i18n.t('http.errors.startEventScanning2') as string);
              throw  e
          })
    }

  httpGetEventsWatchingStatus(): AxiosPromise<EventsProcessingStatus> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      return this.$http.get(`/api/load-events/watching/status`)
          .catch((e) => {
              this.showError(i18n.t('http.errors.getEventScanStatus') as string);
              throw e
          })
  }

  httpGetMinMaxPriceSegment(filter: SkuFilter): AxiosPromise<Segment[]> {
    return this.$http.post('/api/products/price-segment', filter)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadPriceSegment') as string);
          throw  e
        });
  }

  httpGetMinMaxPriceSegmentForKviCarts(filter: SkuFilter): AxiosPromise<Segment[]> {
    return this.$http.post('/api/products/kviProductsPriceSegment', filter)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadPriceSegment2') as string);
          throw  e
        });
  }

  httpGetMinMaxPriceSegmentForNewProducts(filter: SkuFilter): AxiosPromise<Segment[]> {
    return this.$http.post('/api/products/newProductsPriceSegment', filter)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadPriceSegment3') as string);
          throw  e
        });
  }

  httpGetProductSegmentIdAndName(filter: SkuFilter): AxiosPromise<ProductSegmentIdAndName[]> {
    return this.$http.post('/api/products/productSegmentIdAndName', filter)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadProductSegments') as string);
          throw  e
        });
  }

  httpGetProductTagsIdAndNameInLastAssortmentFile(filter: CompetitorsPriceFilter): AxiosPromise<ProductTag[]> {
    return this.$http.post('/api/assortment/productTagsIdAndName', filter)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadProductFilters') as string);

          throw e;
        });
  }

  httpFetchAssortmentFilterOptions(filters: ISalesBasicFilters, params: IFetchAssortmentFilterOptionsParams): AxiosPromise<IHttpFetchAssortmentFilterOptions> {
      return this.$http.post('/api/assortment/options', filters, { params })
          .catch((e) => {
              this.showError(i18n.t('http.errors.loadAssortmentFilterOptions') as string);
              throw e;
          });
  }

  httpGetSkuKeysAndAttributes(filter: SkuFilter): AxiosPromise<SkuCharacteristicsKeysAndAttributes> {
    return this.$http.post('/api/products/getSkuKeysAndAttributes', filter)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadKeyCharacteristics') as string);
          throw  e
        });
  }

  httpGetNewProductSkuKeysAndAttributes(filter: SkuFilter): AxiosPromise<SkuCharacteristicsKeysAndAttributes> {
    return this.$http.post('/api/products/getSkuKeysAndAttributesForNewProducts', filter)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadNewProductKeyCharacteristics') as string);
          throw  e
        });
  }

  httpGetNewProductSegmentIdAndName(filter: SkuFilter): AxiosPromise<ProductSegmentIdAndName[]> {
    return this.$http.post('/api/products/newProductsSegmentIdAndName', filter)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadProductSegments2') as string);
          throw  e
        });
  }

  httpGetPriceSegmentsForDetailReport(taskId: number, type: TaskType): AxiosPromise<ReportDetailSegments[]> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.get(`/api/task/getDetailTableSegmentPrice/${taskId}`, {params: {taskType: type, userId }})
  }

  httpPostHelpPromoSkuList(data: PromoFilters): AxiosPromise<PromoSku[]> {
    return this.$http.post('/api/help/promo-sku-list', data);
  }

  httpGetCalcPromo(data: PromoFilters): AxiosPromise<string> {
    return this.$http.post('/api/task/promo', data);
  }

  httpSalesCalculationStart(data: SalesCalculationFilters): AxiosPromise<string> {
      return this.$http.post('/api/sales/task', data);
  }

  httpPackageSalesCalculationStart(data: SalesCalculationFilters): AxiosPromise<string> {
      return this.$http.post('/api/task/package/sales', data);
  }

  httpPackageModuleItemsCalculationStart(moduleType: TModuleType, data: SaveModuleItemParamsFilter): AxiosPromise<string> {
      return this.$http.post(moduleType === 'promo' ? '/api/task/package/promotions' : '/api/task/package/sales', data);
  }

  httpSalesCreateAggregatedReport(data: CreateAggregatedReportPayloadParams): AxiosPromise<string> {
      return this.$http.post('/api/task/package/aggregate/sales', data);
  }

  httpPromotionsCreateAggregatedReport(data: CreateAggregatedPromotionsReportPayloadParams): AxiosPromise<string> {
      return this.$http.post('/api/task/package/aggregate/promotions', data);
  }

  httpCreateAggregatedReport(moduleType: TModuleType, data: CreateAggregatedModuleReportPayloadParams | CreateAggregatedPromotionsReportPayloadParams): AxiosPromise<string> {
      return this.$http.post(moduleType === 'promo' ? '/api/task/package/aggregate/promotions' : '/api/task/package/aggregate/sales', data);
  }

  httpAddPackageCalcTask(config: PackageCalcConfig): AxiosPromise<string> {
    return this.$http.post('/api/task/packageCalc', config)
  }

  httpAddLoadEvent(config: EventFilter): AxiosPromise<string> {
    return this.$http.post('/api/load-events', config)
  }

  httpAddPackageKviRecommendsTask(config: PackageKviRecommendsConfig): AxiosPromise<string> {
    return this.$http.post('/api/task/packageKviRecommends', config)
  }

  httpAddPackagePromoTask(config: PackagePromoConfig): AxiosPromise<string> {
    return this.$http.post('/api/task/packagePromo', config)
  }

  httpAddPackagePromoRecommendsTask(config: PackagePromoConfig): AxiosPromise<string> {
    return this.$http.post('/api/task/packagePromoRecommends', config)
  }

  httpSaveScheduleCalc(filters: ScheduleCalcFilter, scheduleId: number, isScheduleCross: boolean): AxiosPromise<any> {
    return this.$http.post('/api/scheduleCalc', filters, {
      params: {
        isCross: isScheduleCross,
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveChart', { detail: e }) as string);
          throw  e
        });
  }

  httpCreateEvent(filters: EventFilter): AxiosPromise {
    return this.$http.post(`/api/load-events`, filters)
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveEvent', { detail: e }) as string);
          throw  e
        });
  }

  httpUpdateEvent(filters: EventFilter, eventId: number, isScheduleCross: boolean = false): Promise<AxiosResponse<any> | void> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) { return Promise.reject(); }

      const { user_id: userId } = JSON.parse(auth);

      return this.$http.put(`/api/load-events/${eventId}`, filters, {
          params: {
            isCross: isScheduleCross,
              userId
          },
        })
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveEvent2', { detail: e }) as string);
          throw  e
        });
  }

    httpUpdateEventFilterParams(filters: EventFilter, eventId: number): Promise<AxiosResponse<any> | void> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) { return Promise.reject(); }

        const { user_id: userId } = JSON.parse(auth);

        return this.$http.put(`/api/load-events/${eventId}/filter-params`, filters, {
            params: {
                userId
            },
        })
            .catch((e) => {
                this.showError(i18n.t('http.errors.saveEvent3', { detail: e }) as string);
                throw  e
            });
    }

    httpGetEditEventSelections(eventId: number): AxiosPromise<EventEditData> {
        return this.$http.get(`/api/load-events/${eventId}/eventData`, { params: {eventId} })
            .catch((e) => {
                this.showError(i18n.t('http.errors.getEventEditData') as string);
                throw e
            })
    }

  httpSaveScheduleIndividualCalc(filters: ScheduleIndividualConfigs, id: number): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.put(`/api/scheduleCalc/${id}`, filters, { params: {userId} })
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveIndividualParams', { detail: e }) as string);
          throw  e
        });
  }

  httpSaveEvents(id: number, event: EventIndividualConfigs): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.put(`/api/load-events/${id}`, event, { params: {userId} })
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveIndividualParams2', { detail: e }) as string);
          throw  e
        });
  }

  httpIdenticalCheckScheduleCalc(filters: ScheduleCalcFilter): AxiosPromise<number> {
    return this.$http.post('/api/scheduleCalc/checkIdenticalSchedule', filters);
  }

  httpLoadEventsCheckIdentical(filters: EventFilter): AxiosPromise<FoundEntityEvent> {
    return this.$http.post('/api/load-events/checkIdentical', filters);
  }

  httpCrossCheckScheduleCalc(filters: ScheduleCalcFilter): AxiosPromise<number> {
    return this.$http.post('/api/scheduleCalc/checkCrossSchedule', filters);
  }

  httpLoadEventsCheckCross(filters: EventFilter): AxiosPromise<FoundEntityEvent> {
    return this.$http.post('/api/load-events/checkCross', filters);
  }

  httpGetFileList(pageParams: FilesPageParams): AxiosPromise<Page<ServerFile[]>> {
    return this.$http.get('/api/file/list', {
      params: pageParams,
    });
  }

  httpUploadFile(marketId: number, fileType: FileType, uploadFile: FormData, uploadProgress: (e: any) => void): AxiosPromise<any> {
    return this.$http.post('/api/file/upload-file', uploadFile, {
      headers: {'content-type': 'multipart/form-data'},
      params: {tradingId: marketId, type: fileType},
      onUploadProgress: uploadProgress,
    });
  }

  httpUploadHintsFile(uploadFile: FormData, uploadProgress: (e: any) => void): AxiosPromise<any> {
    return this.$http.post('/api/file/upload-hints-file', uploadFile, {
      headers: {'content-type': 'multipart/form-data'},
      onUploadProgress: uploadProgress,
    });
  }

  httpUploadRoundingRule(filters: FormData, uploadProgress: (e: any) => void): AxiosPromise<any> {
    // this.$log.log(filters)
    return this.$http.post('/api/rounding/upload-rounding-rule', filters, {
      headers: {
        'content-type': 'multipart/form-data',
      },
      onUploadProgress: uploadProgress,
    });
  }

  httpLoadRoundingRules(filter: RoundingRulesFilter, lim: number, off: number): AxiosPromise<Page<BaseFilterRoundingTable[]>> {
    return this.$http.post('/api/rounding/load-regular', filter, {
      params: {
        limit: lim,
        offset: off,
      },
    });
  }

  httpLoadRoundingRulesFilters(id: number, filterType: string): AxiosPromise<AllFiltersForRulesTable> {
    return this.$http.get('/api/rounding/load-filters', {
      params: {
        tradingId: id,
        type: filterType,
      },
    })
  }

  httpDeleteFile(taskId: number): AxiosPromise<any> {
    return this.$http.delete('/api/file/delete', {params: {fileId: taskId}});
  }

  httpUploadSalePointsDirectoryFile(
      tradingNetworkId: number,
      uploadFile: FormData,
      uploadOption: ImportUploadOption
  ): AxiosPromise<any> {
      return this.$http.post('/api/file/upload-sale-points-directory-file', uploadFile, {
          headers: {'content-type': 'multipart/form-data'},
          params: {tradingId: tradingNetworkId, uploadOption: uploadOption}
      });
  }

  httpGetSalePointsDirectoryItems(
      params: SalePointsDirectoryParams
  ): AxiosPromise<Page<SalePointsDirectoryItem[]>> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

      return this.$http.get(`/api/sale-points-directory`, {
          params
      }).catch((e) => {
          this.showError(i18n.t('http.errors.loadDirectory') as string);
          throw e
      });
  }

  httpLoadTradingNetworks(isByReports: boolean = false): AxiosPromise<SelectMarket[]> {
    let queryParams = {};
    if (isByReports) {
      queryParams = Object.assign(queryParams, {byReports: isByReports});
    }
    return this.$http.get('/api/trading/networks', {params: queryParams})
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadCompanies') as string);
          throw  e
        });
  }

    httpGetOKRBCodes(tradingId: number): AxiosPromise<CodeOKRB[]> {
        return this.$http.get('/api/code-okrb/all', {params: {tradingId}})
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadOkrbCodes') as string);
                throw  e
            });
    }

    httpGetOKRBCode(codeOKRB: string): AxiosPromise<CodeOKRB> {
        return this.$http.get('/api/code-okrb', {params: {codeOKRB}})
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadOkrbCodes2') as string);
                throw  e
            });
    }

    httpUpsertOKRBCode(codeOKRB: CodeOKRB): AxiosPromise<CodeOKRB[]> {
        return this.$http.post('/api/code-okrb', codeOKRB)
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadOkrbCodes3') as string);
                throw  e
            });
    }

    httpCheckOKRBCodes(params: OKRBCodesConfig): AxiosPromise<boolean> {
        return this.$http.post('/api/task/checkOKRBCodes', params)
            .catch((e) => {
                this.showError(i18n.t('http.errors.checkOkrbCodes') as string);
                throw  e
            });
    }

    httpCheckOKRBCode(params: OKRBCodeConfig): AxiosPromise<boolean> {
        return this.$http.post('/api/task/checkOKRBCode', params)
            .catch((e) => {
                this.showError(i18n.t('http.errors.checkOkrbCodes2') as string);
                throw  e
            });
    }

  httpLoadKviCartsByTradingId(trId: number): AxiosPromise<SelectKviCart[]> {
    return this.$http.get('/api/kvi-carts/loadAllKviCarts', {params: {tradingId: trId}})
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadKviCarts') as string);
          throw  e
        });
  }

  httpExportKviCartProducts(
      params: {
        kviCartId: number;
        tradingId: number;
        userId: number;
        storeFormatId?: number;
        storeRegionId?: number[];
        storeClusterId?: number;
      }
  ): AxiosPromise<Blob> {
    return this.$http.get('/api/kvi-carts/export', {
      params,
      paramsSerializer: (queryParams) => {
        const result = new URLSearchParams();

        Object.entries(queryParams).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item) => {
              if (item !== null && item !== undefined) {
                result.append(key, String(item));
              }
            });
          } else if (value !== null && value !== undefined) {
            result.append(key, String(value));
          }
        });

        return result.toString();
      },
      responseType: 'blob',
    });
  }

  httpGetTaskList(params: TaskParams): AxiosPromise<Page<TaskData[]>> {
    return this.$http.get('/api/task/list', {
      params,
      paramsSerializer: (params) => {
          const result = new URLSearchParams();

          Object.entries(params).forEach(([key, value]) => {
              if (Array.isArray(value)) {
                  value.forEach(item => {
                      if (item !== null) {
                          result.append(key, item);
                      }
                  });
              } else {
                  if (value !== null) {
                      result.append(key, String(value));
                  }
              }
          });

          return result.toString();
      },
    });
  }

  httpGetCalcTaskList(params: TaskParams): AxiosPromise<Page<TaskData[]>> {
    return this.$http.get('/api/task/list/calc', {
      params,
      paramsSerializer: (params) => {
          const result = new URLSearchParams();

          Object.entries(params).forEach(([key, value]) => {
              if (Array.isArray(value)) {
                  value.forEach(item => {
                      if (item !== null) {
                          result.append(key, item);
                      }
                  });
              } else {
                  if (value !== null) {
                      result.append(key, String(value));
                  }
              }
          });

          return result.toString();
      },
    });
  }

  httpGetSalesTaskList(params: TaskParams): AxiosPromise<Page<TaskData[]>> {
      return this.$http.get('/api/task/list/sales', {
          params,
          paramsSerializer: (params) => {
              const result = new URLSearchParams();

              Object.entries(params).forEach(([key, value]) => {
                  if (Array.isArray(value)) {
                      value.forEach(item => {
                          if (item !== null) {
                              result.append(key, item);
                          }
                      });
                  } else {
                      if (value !== null) {
                          result.append(key, String(value));
                      }
                  }
              });

              return result.toString();
          },
      });
  }

  httpLoadTaskById(id: number): AxiosPromise<TaskData> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.get(`/api/task/${id}`, { params: {userId} })
  }

  httpGetUsersFio(): AxiosPromise<string[]> {
    return this.$http.post('/api/task/getUsersFio');
  }

  httpGetRoundingRulesUsersFio(id: number): AxiosPromise<string[]> {
    return this.$http.get('/api/rounding/getRoundingRulesUsersFio', {params: {tradingId: id}});
  }

  httpDeleteRoundingRulesFile(id: number) {
    return this.$http.delete('/api/rounding/deleteFile', {params: {ruleId: id}})
  }

  httpGetAllReportsIds(params: TaskParams): AxiosPromise<number[]> {
    return this.$http.post('/api/task/getAllTaskIds', params);
  }

  httpGetAllCalcTaskIds(params: TaskParams): AxiosPromise<number[]> {
    return this.$http.post('/api/task/getAllCalcTaskIds', params);
  }

  httpLoadCompetitors(filter: CompetitorsPriceFilter, limitParam: number = 20, offsetParam: number = 0): AxiosPromise<CompetitorsPricesView[]> {
    return this.$http.post('/api/competitors-products', filter, {
      params: {limit: limitParam, offset: offsetParam},
    })
  }

  httpLoadCompetitorsPrice(filter: CompetitorsPriceFilter, limitParam: number = 50, offsetParam: number = 0): AxiosPromise<Page<RegularCompetitorsPricesView[]>> {
      return this.$http.post('/api/competitor-prices', filter, {
          params: {limit: limitParam, offset: offsetParam},
      })
  }

  httpLoadCompetitorsTableFilterOptions(filter: CompetitorsPriceFilter): AxiosPromise<ICompetitorPricesFilterOptions> {
      return this.$http.post('/api/competitor-prices/filter-options', filter, {})
  }

  httpLoadKviCartCompetitorsPrice(filter: CompetitorsPriceFilter, limitParam: number = 50, offsetParam: number = 0): AxiosPromise<Page<RegularCompetitorsPricesView[]>> {
    return this.$http.post('/api/competitor-prices', filter, {
      params: {limit: limitParam, offset: offsetParam},
    })
  }

  httpPostMinRetailPrice(filter: BaseFilter): AxiosPromise<MinRetailPrice> {
    return this.$http.post('/api/task/minRetailPrice', filter);
  }

  httpFindBaseParams(findParams: FindFiltersParams): AxiosPromise<FiltersWithCheckSum<CalcFilters>> {
    return this.$http.post('/api/filters/base', findParams)
  }

  httpFindRulesParams(findParams: FindFiltersParams, ruleType: string): AxiosPromise<BaseFilterRoundingRules> {
    return this.$http.post('/api/rounding/findParams', findParams, {params: {type: ruleType}})
  }

  httpSaveRulesParams(params: BaseFilterRoundingRules) {
    return this.$http.post('/api/rounding/saveRulesParams', params)
  }

  httpFindKviCartParams(findParams: FindFiltersParams): AxiosPromise<FiltersWithCheckSum<KviCartFilters>> {
    return this.$http.post('/api/filters/kviCart', findParams)
  }

  httpSaveKviCartFilter(filter: KviCartFilters): AxiosPromise<string> {
    return this.$http.put('/api/filters/kviCart', filter);
  }

  httpFindPromoParams(findParams: FindFiltersParams): AxiosPromise<FiltersWithCheckSum<PromoFilters>> {
    return this.$http.post('/api/filters/promo', findParams)
  }

  httpFindSalesParams(findParams: FindFiltersParams): AxiosPromise<FiltersWithCheckSum<SalesFilters>> {
      return this.$http.post('/api/filters/sales', findParams);
  }

  httpFindModuleItemParams(moduleType: TModuleType, findParams: FindFiltersParams): AxiosPromise<FiltersWithCheckSum<ModuleItemFilters>> {
      return this.$http.post(moduleType === 'promo' ? '/api/filters/promotions' : '/api/filters/sales', findParams);
  }

  httpFindPromotionsCategoryParams(findParams: FindFiltersParams): AxiosPromise<FiltersWithCheckSum<ModuleItemFilters>> {
      return this.$http.post('/api/filters/promo', findParams);
  }

  httpSavePromotionsCategoryParams(data: CategoryFindFiltersPayload & CategoryParamsValues & {
      competitorsPromoPriceMethod: CompetitorsPriceMethods;
      competitorsPromoPriceStrategy: CompetitorsPriceStrategies;
  }): AxiosPromise<string> {
      return this.$http.put('/api/filters/promo', data);
  }

  httpGetConfig(): AxiosPromise<Config> {
    return this.$http.get('/api/config');
  }

  httpFetchUsersList(pageParams: PageParams): AxiosPromise<Page<User[]>> {
    return this.$http.get('/api/users', {params: pageParams});
  }

  httpCreateUser(user: UserForm): AxiosPromise<User> {
    return this.$http.post('/api/users', user)
  }

  httpDeleteUser(uid: number): AxiosPromise<User> {
    return this.$http.delete(`/api/users/${uid}`)
  }

  httpChangeUserStatus(uid: number): AxiosPromise<User> {
    return this.$http.post(`/api/users/${uid}/change-status`)
  }

  httpChangeUserRole(uid: number): AxiosPromise<User> {
    return this.$http.post(`/api/users/${uid}/change-role`)
  }

  httpChangeUserPassword(uid: number, changePassword: ChangePassword): AxiosPromise<User> {
    return this.$http.post(`/api/users/${uid}/change-password`, changePassword)
  }

  httpChangeUserFio(uid: number, userFio: string): AxiosPromise<User> {
    return this.$http.post(`/api/users/${uid}/change-fio`, null, {
      params: {
        fio: userFio,
      },
    })
  }

  httpChangeUserEmail(uid: number, userEmail: string): AxiosPromise<User> {
    return this.$http.post(`/api/users/${uid}/change-email`, null, {
      params: {
        email: userEmail,
      },
    })
  }

  httpChangeNotifications(
      uid: number,
      loadingErrors: boolean,
      generatedReport: boolean,
      revaluationStatusNotification: boolean,
      revaluationOnFinalApproveStatusNotification: boolean,
      fixedPriceStatusNotification: boolean,
      revaluationFtpExportNotification: boolean
  ): AxiosPromise<User> {
    const notificationsArray = []
    if (loadingErrors) {
      notificationsArray.push('diskSpaceError')
      notificationsArray.push('criticalErrors')
      notificationsArray.push('warningsWithAttachment')
    }
    if (generatedReport) {
      notificationsArray.push('generatedReport')
    }
    if (revaluationStatusNotification) {
        notificationsArray.push('revaluationStatusNotification')
    }
    if (revaluationOnFinalApproveStatusNotification) {
        notificationsArray.push('revaluationOnFinalApproveStatusNotification')
    }
    if (fixedPriceStatusNotification) {
        notificationsArray.push('fixedPriceStatusNotification')
    }
    if (revaluationFtpExportNotification) {
        notificationsArray.push('revaluationFtpExportNotification')
    }
    return this.$http.post(`/api/users/${uid}/change-notifications`, notificationsArray)
  }

  httpGetNotifications(uid: number): AxiosPromise<String[]> {
    return this.$http.get(`/api/users/${uid}/notifications`)
  }

  httpChangeUserPermissions(uid: number, userPermissions: UserPermissions): AxiosPromise<User> {
    return this.$http.post(`/api/users/${uid}/change-userAccessToParams`, userPermissions)
  }

  httpChangeUserAdditionalRoles(uid: number, roles: Partial<Record<AdditionalRole, boolean>>): AxiosPromise<User> {
    return this.$http.post(`/api/users/${uid}/change-user-additional-roles`, roles)
  }

  httpChangeUserVice(uid: number, viceId: number | null): AxiosPromise<any> {
      return this.$http.patch(`/api/users/${uid}/vice`, { viceId })
          .catch((e) => {
              this.showError(i18n.t('http.errors.assignDeputy') as string);
              throw  e
          });
  }

  httpFetchUsersShortInfoList(): AxiosPromise<UserShortInfo[]> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

      return this.$http.get(`/api/users/short-info/list`)
          .catch((e) => {
              this.showError(i18n.t('http.errors.getUserBriefInfo') as string)
              throw e
          })
  }

  httpGetTradingNetworks(): AxiosPromise<IdAndName[]> {
    return this.$http.get(`/api/users/trading-networks`);
  }

  httpGetGroups(tradingId: number): AxiosPromise<IdAndName[]> {
    return this.$http.get(`/api/users/trading-networks/${tradingId}/groups`);
  }

  httpGetCategories(tradingId: number, groupId: number): AxiosPromise<IdAndName[]> {
    return this.$http.get(`/api/users/trading-networks/${tradingId}/groups/${groupId}/categories`);
  }

  httpGetUserTags(uid: number): AxiosPromise<UserTradingNetworkTreeItem[]> {
    return this.$http.get(`/api/users/${uid}/tags`);
  }

  httpSetUserTags(uid: number, userTags: SetUserTradingNetworkTreeItem[]) {
    return this.$http.post(`/api/users/${uid}/tags`, userTags);
  }

  httpSaveBaseFilter(filter: CalcFilters): AxiosPromise<string> {
    return this.$http.put('/api/filters/base', filter);
  }

  httpSavePromoFilter(filter: PromoFilters): AxiosPromise<string> {
    return this.$http.put('/api/filters/promo', filter);
  }

  httpSaveSalesFilter(filter: SalesCalculationFilters): AxiosPromise<string> {
      return this.$http.put('/api/filters/sales', filter);
  }

  httpSaveItemParamsFilter(moduleType: TModuleType, filter: SaveModuleItemParamsFilter): AxiosPromise<string> {
      return this.$http.put(moduleType === 'promo' ? '/api/filters/promotions' : '/api/filters/sales', filter);
  }

  httpSaveBaseIndividualConfig(data: IndividualConfigCmd<CalcIndividualConfigMap>): AxiosPromise<any> {
    return this.$http.put('/api/filters/base/individual', data)
  }

  httpSaveBaseIndividualConfigForSale(data: IndividualConfigCmd<CalcIndividualConfigMap>): AxiosPromise<any> {
      return Promise.resolve({
          data: {
              success: true,
          },
          status: 200,
          statusText: 'OK',
          headers: {},
          config: {},
          request: {}
      });
  }

  httpSaveKviCartIndividualConfig(data: IndividualConfigCmd<CalcIndividualConfigMap>): AxiosPromise<any> {
    return this.$http.put('/api/filters/kviCart/individual', data)
  }

  httpSavePromoIndividualConfig(data: IndividualConfigCmd<PromoIndividualConfigMap>): AxiosPromise<any> {
    return this.$http.put('/api/filters/promo/individual', data)
  }

  httpSaveSaleIndividualConfig(data: SaleIndividualConfigFieldsToSave): AxiosPromise<any> {
      return this.$http.patch(`/api/sales/sale-products`, data)
          .catch((e) => {
              this.showError(i18n.t('http.errors.saveIndividualParams') as string);
              throw  e
          });
  }

  httpSaveModuleItemIndividualConfig(moduleType: TModuleType, data: ModuleItemIndividualConfigFieldsToSave): AxiosPromise<any> {
      return this.$http.patch(moduleType === 'promo' ? '/api/promotions/products' : '/api/sales/sale-products', data)
          .catch((e) => {
              this.showError(i18n.t('http.errors.saveIndividualParams2') as string);
              throw e;
          });
  }

  httpLoadBaseIndividual(findParams: FindFiltersParams): AxiosPromise<CalcIndividualConfigMap> {
    return this.$http.post('/api/filters/base/individual', findParams)
  }

  httpLoadKviCartIndividual(findParams: FindFiltersParams): AxiosPromise<CalcIndividualConfigMap> {
    return this.$http.post('/api/filters/kviCart/individual', findParams)
  }

  httpLoadPromoIndividual(findParams: FindFiltersParams): AxiosPromise<PromoIndividualConfigMap> {
    return this.$http.post('/api/filters/promo/individual', findParams)
  }

  httpLoadSalesIndividual(findParams: FindFiltersParams): AxiosPromise<SaleIndividualConfigMap> {
      // return this.$http.post('/api/filters/sales/individual', findParams); // or other route - see BackEnd after it creation
      return this.$http.post('/api/filters/promo/individual', findParams); // temporary
  }

  httpGetPackageTasksCount(config: PackageCalcConfig): AxiosPromise<PackageTasksCount> {
    return this.$http.post('/api/task/package/count', config)
  }

  httpMoveTaskFilter(taskIds: number[]): AxiosPromise<any> {
    return this.$http.post('/api/filters/base/move', taskIds);
  }

  httpCancelTask(taskIds: number[]): AxiosPromise<number[]> {
    return this.$http.post('/api/task/cancelTask', taskIds)
        .catch((e) => {
          this.showError(i18n.t('http.errors.cancelReports') as string);
          throw  e
        });
  }

  httpCancelCalcTask(taskIds: number[]): AxiosPromise<number[]> {
    return this.$http.post('/api/task/cancelTask/calc', taskIds)
        .catch((e) => {
          this.showError(i18n.t('http.errors.cancelReports') as string);
          throw e;
        });
  }

  httpRestartTask(taskIds: number[]): AxiosPromise<number[]> {
    return this.$http.post('/api/task/restartTask', taskIds)
        .catch((e) => {
          this.showError(i18n.t('http.errors.restartReports') as string);
          throw  e
        });
  }

  httpCheckUnfinishedReports(): AxiosPromise<number[]> {
    return this.$http.get('/api/task/checkUnfinishReports')
        .catch((e) => {
          this.showError(i18n.t('http.errors.getQueuedReports') as string);
          throw  e
        });
  }

  httpCheckCancelReports(): AxiosPromise<number[]> {
    return this.$http.get('/api/task/checkCancelReports')
        .catch((e) => {
          this.showError(i18n.t('http.errors.getCancelledReports') as string);
          throw  e
        });
  }

  httpStopBrutForce(taskIdNumber: number): AxiosPromise<any> {
    return this.$http.post('/api/task/stop-brut-force', null, {
      params: {
        taskId: taskIdNumber,
      },
    })
  }

  httpGetRegularPricesProfitability(filter: SkuFilter): AxiosPromise<number> {
    return this.$http.post('/api/products/getRegularPricesProfitability', filter)
  }

  httpExistsInOtherKviCartByFilterAndCode(filter: KviCartFilters): AxiosPromise<KviCartConflictingItemDto[]> {
      return this.$http.post('/api/kvi-carts/products-exists-in-other-kvi-cart', filter)
          .catch((e) => {
            this.showError(i18n.t('http.errors.checkProductsInOtherCarts') as string);
            throw e
          });
  }

  httpAddSelectedProductsToKviCart(filter: KviCartFilters): AxiosPromise<any> {
    return this.$http.post('/api/kvi-carts/addProductsToKviCart', filter)
  }

  // TODO удалить httpAddSelectedProductToSale после того, как Распродажи будут переключены на новый модуль
  httpAddSelectedProductToSale(filter: any): AxiosPromise<any> {
      return this.$http.post('/api/sales/add-products-to-sale', filter)
  }

  httpAddSelectedProductToModuleItem(moduleType: TModuleType, filter: any): AxiosPromise<any> {
      return this.$http.post(moduleType === 'promo' ? '/api/promotions/products' : '/api/sales/add-products-to-sale', filter);
  }

  // TODO удалить httpGetSalesSkuList после того, как Распродажи будут переключены на новый модуль
  httpGetSalesSkuList(filter: SkuFilter, skuListLimit: number, nextSkuListOffset: number): AxiosPromise<Page<Array<Sku & { storeCluster: IidAndName }>>> {
      return this.$http.post('/api/sales/sale-products-list', filter, {
          params: {
              limit: skuListLimit,
              offset: nextSkuListOffset,
          },
      })
      .catch((e) => {
          this.showError(i18n.t('http.errors.loadProducts5') as string);
          throw e;
      });
  }

  httpGetModuleItemSkuList(moduleType: TModuleType, filter: SkuFilter, skuListLimit: number, nextSkuListOffset: number): AxiosPromise<Page<Array<Sku & { storeCluster: IidAndName }>>> {
      return this.$http.post(
          moduleType === 'promo' ? '/api/promotions/products/list' : '/api/sales/sale-products-list',
          filter,
          {
              params: {
                  limit: skuListLimit,
                  offset: nextSkuListOffset,
              },
          })
          .catch((e) => {
              this.showError(i18n.t('http.errors.loadProducts6') as string);
              throw e;
          });
  }

  httpDeleteSelectedProductsFromKviCart(kviCartProductIds: Array<number>): AxiosPromise<any> {
    return this.$http.post('/api/kvi-carts/deleteProductsFromKviCart', kviCartProductIds)
  }

    httpHasActiveCalculations(tradingId: number): AxiosPromise<boolean> {
        return this.$http.get('/api/task/has-active-calculations', {
            params: {
                tradingId: tradingId
            },
        })
            .catch((e) => {
                this.showError(i18n.t('http.errors.checkActiveCalculations', { detail: e }) as string);
                throw  e
            });
    }

  httpDeleteSelectedProductsFromSale(filter: SkuFilter): AxiosPromise<any> {
      return this.$http.post('/api/sales/delete-sale-products', filter)
  }

  httpDeleteSelectedProductsFromModuleItem(moduleType: TModuleType, filter: IModuleItemDeleteProductsFilter): AxiosPromise<any> {
      return this.$http.post(moduleType === 'promo' ? '/api/promotions/products/delete' : '/api/sales/delete-sale-products', filter);
  }

  httpGetActualProfitability(filter: SkuFilter): AxiosPromise<number> {
    return this.$http.post('/api/products/getActualProfitability', filter)
  }

  httpGetGroupByCategory(category: number): AxiosPromise<number> {
    return this.$http.post('/api/products/getGroupByCategoryId', null, {
      params: {
        categoryId: category,
      },
    })
  }

  httpGetGroupsByCategoryIds(categories: number[]): AxiosPromise<number[]> {
    return this.$http.post('/api/products/getGroupIdsByCategories', categories)
  }

  httpGetFtpParameters(): AxiosPromise<FtpSettings> {
    return this.$http.get('/api/ftp/load')
        .catch((e) => {
          this.showError(i18n.t('http.errors.getFtpParams', { detail: e }) as string);
          throw  e
        });
  }

  httpSaveFtpParameters(ftpParams: FtpParameters): AxiosPromise<any> {
    return this.$http.post('/api/ftp/save', ftpParams)
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveFtpParams', { detail: e }) as string);
          throw  e
        });
  }

  httpSaveMoneyCodes(moneyCodesList: TradingAndMoney[]): AxiosPromise<any> {
    return this.$http.post('/api/money/save', moneyCodesList)
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveCurrencyCodes', { detail: e }) as string);
          throw  e
        });
  }

  httpGetMoneyCodes(): AxiosPromise<TradingAndMoney[]> {
    return this.$http.get('/api/money/load')
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadCurrencyCodes', { detail: e }) as string);
          throw  e
        });
  }

  httpGetFtpUsersAndTradings(): AxiosPromise<FtpUsersAndTradings[]> {
    return this.$http.get('/api/ftp-users/load')
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadFtpUsers', { detail: e }) as string);
          throw  e
        });
  }

  httpSaveFtpUsersAndTradings(ftpUsersAndTradings: FtpUsersAndTradings[]): AxiosPromise<any> {
    return this.$http.post('/api/ftp-users/save', ftpUsersAndTradings)
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveFtpUsers', { detail: e }) as string);
          throw  e
        });
  }

  httpResetFtpParameters(configName: string): AxiosPromise<any> {
    return this.$http.post('/api/ftp/reset', null, {
      params: {
        configKey: configName,
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.resetFtpParams', { detail: e }) as string);
          throw  e
        });
  }

  httpSendReportToFtpServer(taskIds: number[]): AxiosPromise<string> {
    return this.$http.post('/api/task/sendToFtp', taskIds)
        .catch((e) => {
          throw  e
        });
  }

  httpSaveCorrectedRegularPrices(taskId: number, type: TaskType, params: DetailReportsPricesAndCodes): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.put(`/api/task/recalculateRegular/${taskId}`, params, {params: {taskType: type, userId }})
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveCorrectedPrices', { detail: e }) as string);
          throw  e
        })
  }

  httpCheckHasCorrectedRegularPrices(taskId: number, type: TaskType): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

      return this.$http.get(`/api/task/${taskId}/check-has-corrected-prices`, {params: {taskType: type, userId }})
          .catch((e) => {
              this.showError(i18n.t('http.errors.checkCorrectedPricesInReport', { detail: e }) as string);
              throw  e
          })
  }

  httpSaveCorrectedPromoPrices(taskId: number, type: TaskType, params: DetailReportsPricesAndCodes): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.put(`/api/task/recalculatePromo/${taskId}`, params, {params: {taskType: type, userId }})
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveCorrectedPrices2', { detail: e }) as string);
          throw  e
        })
  }

  httpSetManualParamsToPromoFiles(findFilterParams: PromoFilesFilterParams): AxiosPromise<any> {
    return this.$http.post('/api/promo-files/updatePromoFiles', findFilterParams)
        .catch((e) => {
          this.showError(i18n.t('http.errors.changePromoFileParams', { detail: e }) as string);
          throw  e
        });
  }

  httpFetchParametersList(filterData: ParametersListFilterData, query: ParametersListQuery): AxiosPromise<Page<ParamsListItem[]>> {
    return this.$http.post('/api/filters/rules-list', filterData, { params: query })
        .catch((e) => {
          this.showError(i18n.t('http.errors.getCalcRules', { detail: e }) as string);
          throw  e
        });
  }

  httpFetchIndividualParametersList(filterData: ParametersListFilterData, query: ParametersListQuery): AxiosPromise<Page<ParamsListItem[]>> {
    return this.$http.post('/api/filters/rules-list/individual', filterData, { params: query })
        .catch((e) => {
          this.showError(i18n.t('http.errors.getIndividualRules', { detail: e }) as string);
          throw e;
        });
  }

  httpFetchEventsTriggers(query: EventsListQuery): AxiosPromise<Page<EventsListItem[]>> {
    return this.$http.get('/api/load-events-triggers', {params: query})
        .catch((e) => {
          this.showError(i18n.t('http.errors.getEvents', { detail: e }) as string);
          throw  e
        });
  }

  httpFetchEventsProducts(id: number, query: EventsListQuery): AxiosPromise<Page<EventsListProductItem[]>> {
    return this.$http.get(`/api/load-events-triggers/${id}`, {params: query})
        .catch((e) => {
          this.showError(i18n.t('http.errors.getEvents2', { detail: e }) as string);
          throw  e
        });
  }

  httpFetchEventsCalcParams(eventsCalcParams: EventsCalcParams): AxiosPromise<EventsParameters> {
    this.$log.info(eventsCalcParams)
    return this.$http.post(`/api/load-events/loadCalcParams`, eventsCalcParams)
        .catch((e) => {
          this.showError(i18n.t('http.errors.getCalcParams', { detail: e }) as string);
          throw e
        });
  }

  httpSaveEventsCalcParams(eventsCalcParams: EventsAddCalcParams): AxiosPromise<EventsParameters> {
    return this.$http.put(`/api/load-events/saveCalcParams`, eventsCalcParams)
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveCalcParams', { detail: e }) as string);
          throw  e
        });
  }

  httpFetchIndividualById(id: number): AxiosPromise<CalcIndividualConfigMap> {
    return this.$http.get(`/api/filters/base/individual/${id}`)
        .catch((e) => {
          this.showError(i18n.t('http.errors.getIndividualSettings', { detail: e }) as string);
          throw  e
        });
  }

  httpFetchIndividualByBaseId(id: number): AxiosPromise<CalcIndividualConfigMap> {
    return this.$http.get(`/api/filters/base/${id}/individual`)
        .catch((e) => {
          this.showError(i18n.t('http.errors.getIndividualSettings2', { detail: e }) as string);
          throw  e
        });
  }

  httpGetFileIdErrorsForRulesList(tradingId: number): AxiosPromise<number> {
    return this.$http.get(`/api/file/getErrorFileIdForRulesList/${tradingId}`)
        .catch((e) => {
          this.showError(i18n.t('http.errors.getErrorsFile') as string);
          throw  e
        });
  }

  httpGetErrorFileIdForIndividualParamsDownload(tradingId: number): AxiosPromise<number> {
    return this.$http.get(`/api/file/getErrorFileIdForIndividualParamsDownload/${tradingId}`)
        .catch((e) => {
          this.showError(i18n.t('http.errors.getErrorsFile2') as string);
          throw  e
        });
  }

  httpRejectTask(taskIds: number[]): AxiosPromise<any> {
    return this.$http.post('/api/task/rejectTasks', taskIds)
  }

  httpSendToFinalApprovalTasks(taskIds: number[]): AxiosPromise<any> {
      return this.$http.post('/api/task/sendToFinalApprovalTasks', taskIds)
  }

  httpApproveTask(taskIds: number[]): AxiosPromise<any> {
    return this.$http.post('/api/task/approveTasks', taskIds)
  }

  httpGetRevaluationQuotas(): AxiosPromise<RevaluationQuotasOfTradingNetwork[]> {
    return this.$http.get('/api/revaluation-quotas')
        .catch((e) => {
          this.showError(i18n.t('http.errors.getQuotas') as string);
          throw e
        });
  }

  httpSaveRevaluationQuotas(quotas: RevaluationQuotasToSave[]): AxiosPromise<RevaluationQuotasOfTradingNetwork[]> {
    return this.$http.post('/api/revaluation-quotas', quotas)
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveQuotas') as string);
          throw e
        });
  }

  httpGetDefaultQuota(): AxiosPromise<RevaluationQuotesData> {
    return this.$http.post('/api/revaluation-quotas/getDefaultQuota');
  }

  httpGetRevaluationQuotasList(listLimit: number, listOffset: number): AxiosPromise<Page<RevaluationQuotesData[]>> {
    return this.$http.post('/api/revaluation-quotas/getQuotasList', null, {
      params: {
        limit: listLimit,
        offset: listOffset,
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadQuotas') as string);
          throw  e
        });
  }
  httpGetFtpRevaluationsParams(): AxiosPromise<RevaluationFtpParams> {
    return this.$http.post('/api/ftp/getFtpRevaluationsParams');
  }

  httpSaveFtpRevaluationParams(params: RevaluationFtpParams): AxiosPromise<any> {
    return this.$http.post('/api/ftp/saveFtpRevaluationsParams', params);
  }

  httpManualSendApprovedRevaluationsToFtp(selectedTradings: SelectMarket[]): AxiosPromise<any> {
    return this.$http.post('/api/revaluation-quotas/manualSendApprovedRevaluationsToFtp', selectedTradings);
  }

  httpManualSendPackageSalesToFtp(selectedTradings: SelectMarket[]): AxiosPromise<any> {
    return this.$http.post('/api/revaluation-quotas/manualSendPackageSalesToFtp', selectedTradings);
  }

  httpCheckMajorPriceChangeInRevaluation(selectedTradings: SelectMarket[]): AxiosPromise<boolean> {
    return this.$http.post('/api/revaluation-quotas/price-change-check', selectedTradings)
         .catch((error) => {
             this.showError(i18n.t('http.errors.checkRevaluationPriceChange', { detail: error }) as string);
             throw error;
         });
  }

  httpRecalculateQueue(): AxiosPromise<any> {
    return this.$http.post('/api/revaluation-quotas/recalculateQueue');
  }

  httpRemoveRevertProductsFromRevaluationQueue(request: AssortmentDateRequest): AxiosPromise<any> {
    return this.$http.post('/api/revaluation-quotas/remove-revert-products-from-queue', request)
  }

  httpRevertRevaluationToAssortment(request: AssortmentDateRequest): AxiosPromise<any> {
    return this.$http.post('/api/revaluation-quotas/revert-revaluation-to-assortment', request);
  }

  httpGetRevaluationQueue(params: RevaluationQueueListRequestParams): AxiosPromise<Page<RevaluationQueueItem[]>> {
    return this.$http.post('/api/revaluation-quotas/queue', params)
  }

  httpGetRevaluationQueueFile(params: RevaluationQueueListRequestParams): AxiosPromise<any> {
    const auth = localStorage.getItem('AUTH');
    if (!auth) return Promise.reject();

    return this.$http.post('/api/revaluation-quotas/queue/export', params, {
        method: 'GET',
        responseType: 'blob'
    }).catch((e) => {
        this.showError(i18n.t('http.errors.exportRevaluationQueueFile') as string);
        throw e
    })
  }

  httpGetRevaluationCheckedSalesPointsByTradingId(tradingAndSalePoints: MarketWithSalePoints): AxiosPromise<string[]> {
    return this.$http.post('/api/revaluation-quotas/getRevaluationCheckedSalesPointsByTradingId/', tradingAndSalePoints)
  }

  httpSaveTradingsAndSalePoints(tradingAndSalePoints: MarketWithSalePoints): AxiosPromise<any> {
    return this.$http.post('/api/revaluation-quotas/saveRevaluationTradingsAndSalePoints', tradingAndSalePoints)
  }

  httpSaveSelectedByInternalCodeRevaluationQueueProducts(
      tradingNetworkId: number,
      taskId: number,
      internalCode: string,
      isIncluded: boolean,
  ): AxiosPromise {
    return this.$http.post('/api/revaluation-quotas/queue/products/internal-code', {}, {
      params: {
        internalCode,
        tradingNetworkId,
        taskId,
        isIncluded,
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveProductExclusion', { detail: e }) as string);
          throw e
        });
  }

  httpSaveSelectedByFiltersRevaluationQueueProducts(
      filters: RevaluationQueueFilters,
      tradingNetworkId: number,
      isIncluded: boolean,
  ): AxiosPromise {
    return this.$http.post('/api/revaluation-quotas/queue/products/filters', filters, {
      params: {
        tradingNetworkId,
        isIncluded,
      },
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveProductExclusion2', { detail: e }) as string);
          throw e
        });
  }
  httpSaveRevaluationCustomSendingDate(
      taskId: number,
      internalCode: string,
      date: string | null,
  ): AxiosPromise {
    return this.$http.post(`/api/revaluation-quotas/queue/product/custom-sending-date`, {
      taskId,
      internalCode,
      date,
    })
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveSetDate', { detail: e }) as string);
          throw e
        });
  }

    httpSaveRevaluationCustomSendingDateBroadcast(
        filterParams: RevaluationQueueListRequestParams,
        date: string | null
    ): AxiosPromise {
        return this.$http.post(`/api/revaluation-quotas/queue/product/custom-sending-date-broadcast`, {
            filterParams,
            date
        })
            .catch((e) => {
                this.showError(i18n.t('http.errors.saveSetDate2', { detail: e }) as string);
                throw e
            });
    }

    httpSaveRevaluationPriceActivationTimeBroadcast(
        filterParams: RevaluationQueueListRequestParams,
        priceActivationTime: string
    ): AxiosPromise {
        return this.$http.post(`/api/revaluation-quotas/queue/product/price-activation-time-broadcast`, {
            filterParams,
            priceActivationTime
        })
            .catch((e) => {
                // Бэк при нарушении валидации возвращает 400 с готовым текстом сообщения
                const backendMessage = e && e.response && e.response.status === 400
                    && typeof e.response.data === 'string' && e.response.data.length > 0
                    ? e.response.data
                    : null;
                this.showError(backendMessage != null
                    ? backendMessage
                    : i18n.t('http.errors.savePriceActivationTime', { detail: e }) as string);
                throw e
            });
    }


  httpSaveRevaluationQueueColumns(columns: string[]): AxiosPromise<string[]> {
    return this.$http.post('/api/revaluation-quotas/columns', columns)
        .catch((e) => {
          this.showError(i18n.t('http.errors.saveColumnSettings', { detail: e }) as string);
          throw e
        });
  }
  httpGetRevaluationQueueColumns(): AxiosPromise<string[]> {
    return this.$http.get('/api/revaluation-quotas/columns')
        .catch((e) => {
          this.showError(i18n.t('http.errors.getColumnSettings', { detail: e }) as string);
          throw e
        });
  }

  httpGetRevaluationQueueFilters(tradingNetworkId: number, isSent: boolean, baseFilter: BaseFilterNames, advancedFilters: AdvancedFilterNames): AxiosPromise<RevaluationQueueFilters> {
    return this.$http.post('/api/revaluation-quotas/filters', { baseFilters: baseFilter, advancedFilters: advancedFilters }, {params: {tradingNetworkId, isSent}})
        .catch((e) => {
          this.showError(i18n.t('http.errors.getFilters', { detail: e }) as string);
          throw e
        });
  }

  httpGetStoreFormats(tradingNetworkId: number): AxiosPromise<IdAndName[]> {
    return this.$http.get('/api/help/store-formats', {params: {tradingNetworkId}})
        .catch((e) => {
          this.showError(i18n.t('http.errors.getFormats', { detail: e }) as string);
          throw e
        });
  }

  httpCheckApprovedRevaluationsTasks(): AxiosPromise<boolean> {
    return this.$http.post('/api/revaluation-quotas/checkApprovedRevaluationsTasks');
  }

  httpCreateNote(taskId: number, taskNote: TaskNoteDTO) {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    this.$http.post(`/api/task/createNote/${taskId}`, taskNote, { params: {userId} })
        .catch((err) => {
          this.showError(i18n.t('http.errors.createNote') as string);
        });
  }

  httpGetReportDetailFieldsByUserId(type: 'regular' | 'promo' | 'sales' | 'price-exp', params: IGetReportDetailFieldsByUserIdParams = {}): AxiosPromise<ReportDetailFieldsView[]> {
    return this.$http.post(`/api/users/getReportDetailFieldsByUserId/${type}`, {}, { params })
        .catch((err) => {
          this.showError(i18n.t('http.errors.loadDetailedReportFields') as string);
          throw  err
        });
  }

  httpChangeReportDetailColumnsStatus(type: 'regular' | 'promo' | 'sales' | 'price-exp', params: ReportDetailColumnsForAddOrDelete): AxiosPromise<any> {
    return this.$http.post(`/api/users/changeReportDetailColumnsStatus/${type}`, params);
  }

  httpFindPackageBaseParams(taskId: number): AxiosPromise<CalcFilters> {
    return this.$http.post(`/api/filters/getPackageBaseParams/${taskId}`)
  }

  httpFindPackagePromoParams(taskId: number): AxiosPromise<PromoFilters> {
    return this.$http.post(`/api/filters/getPackagePromoParams/${taskId}`)
  }

  httpRestartPackageTaskFromDetailParams(taskId: number, params: PackageParamsInDetailReportFilters): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.post(`/api/task/restartPackageTaskFromDetailParams/${taskId}`, params, { params: {userId} });
  }

  httpSaveScenarioAnalysis(params: ScenariosWithFilters): AxiosPromise<string> {
    return this.$http.post('/api/scenario-analysis/save', params)
  }

  httpLoadScenarios(params: ScenariosWithFilters): AxiosPromise<ScenarioNameWithFilters[]> {
    return this.$http.post('/api/scenario-analysis/load', params)
  }

  httpRunPackageScenarioTask(params: ScenariosWithFilters): AxiosPromise<string> {
    return this.$http.post('/api/task/packageScenarioCalc', params)
  }

  httpRecalculateGeneralTask(generalTaskId: number): AxiosPromise<any> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);

    return this.$http.post(`/api/task/recalculateGeneralTask/${generalTaskId}`, null, { params: {userId} })
        .catch((e) => {
          this.showError(i18n.t('http.errors.recalculateReport') as string);
          throw  e
        });
  }

  httpRecalculateSales(request: any): AxiosPromise<any> {
    const auth = localStorage.getItem('AUTH');
    if (!auth) return Promise.reject();

    const { user_id: userId } = JSON.parse(auth);

    return this.$http.post(`/api/task/recalculate/sales`, request, { params: { userId } })
      .catch((e) => {
        this.showError(i18n.t('http.errors.regenerateSalesReport') as string);
        throw e;
      });
  }

  httpRecalculatePromotions(request: any): AxiosPromise<any> {
      return this.$http.post(`/api/task/recalculate/promotions`, request, {})
          .catch((e) => {
              this.showError(i18n.t('http.errors.regeneratePromoReport') as string);

              throw e;
          });
  }

  httpRecalculatePriceExp(request: any): AxiosPromise<any> {
    const auth = localStorage.getItem('AUTH');
    if (!auth) return Promise.reject();

    const { user_id: userId } = JSON.parse(auth);

    return this.$http.post(`/api/task/recalculate/price-exp`, request, { params: { userId } })
      .catch((e) => {
        this.showError(i18n.t('http.errors.regeneratePriceExpReport') as string);
        throw e;
      });
  }

  httpLoadModuleHints(module: string): AxiosPromise<Hints[]> {
    return this.$http.post('/api/hints/load-hints/', null, {params: {hintsModule: module}})
  }

  httpSavePreCalc(params: PreCalcFilters): AxiosPromise<string> {
    return this.$http.post('/api/pre-calculations/save', params)
  }

  httpGetSavedPreCalcReports(smallFilter: SmallPreCalcListFilter, preCalcListLimit: number, nextPreCalcListOffset: number): AxiosPromise<Page<PreCalcColumns[]>> {
    return this.$http.post('/api/pre-calculations/list', smallFilter, {
      params: {
        limit: preCalcListLimit,
        offset: nextPreCalcListOffset,
      },
    }).catch((e) => {
      this.showError(i18n.t('http.errors.loadSavedPrecalculations') as string);
      throw  e
    });
  }

  httpGetAllTradingsPreCalc(): AxiosPromise<ProductTag[]> {
    return this.$http.post('/api/pre-calculations/getAllTradingsPreCalc')
  }

  httpGetAllFiltersInPreCalcReports(tradingId: number): AxiosPromise<AllPreCalcFilterNamesForTable> {
    return this.$http.post(`/api/pre-calculations/getAllFilters/${tradingId}`)
        .catch((e) => {
          this.showError(i18n.t('http.errors.loadPrecalcTableFilters') as string);
          throw  e
        });
  }

  httpSavePreCalcIndividual(filters: PreCalcIndividualConfigs, id: number): AxiosPromise<any> {
    return this.$http.put(`/api/pre-calculations/${id}`, filters)
        .catch((e) => {
          this.showError(i18n.t('http.errors.savePrecalcIndividualParams', { detail: e }) as string);
          throw  e
        });
  }

  httpDeletePreCalc(id: number): AxiosPromise<any> {
    return this.$http.delete(`/api/pre-calculations/${id}`);
  }

  httpStopPreCalc(id: number): AxiosPromise<any> {
    return this.$http.post(`/api/pre-calculations/stop/${id}`);
  }

  httpGetPreCalcSettings(): AxiosPromise<PreCalcStartSettings> {
    return this.$http.post('/api/pre-calculations/getSettings');
  }

  httpSavePreCalcStartParams(params: PreCalcStartSettings): AxiosPromise<any> {
    return this.$http.post('/api/pre-calculations/savePreCalcStartSettings', params);
  }

  httpLoadGrabberConfigs(page: number, size: number): AxiosPromise<Page<IGrabbingConfigDTO[]>> {
    return this.$http.get('/api/grabbing/configs', {params: {page, size}})
  }

  httpSaveGrabberConfig(config: ISaveGrabbingConfigDTO): AxiosPromise<IGrabbingConfigDTO> {
    return this.$http.put(`/api/grabbing/configs`, config)
  }

  httpDeleteGrabberConfig(tradingNetId: number): AxiosPromise<any> {
    return this.$http.delete(`/api/grabbing/configs/${tradingNetId}`)
  }

  httpCallGrabbing(params: ICallGrabbingDTO): AxiosPromise<any> {
    return this.$http.post('/api/grabbing/execute', params);
  }

  httpGetAllSalesPointsByTradingId(tradingId: number): AxiosPromise<CodeSalesPointDto[]> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      const { user_id: userId } = JSON.parse(auth);
    return this.$http.post(`/api/revaluation-quotas/getAllSalesPointsByTradingId/${tradingId}`, null, { params: { userId } })
  }

    httpSaveDefaultTradingNetwork(tradingId: number): AxiosPromise<any> {
      return this.$http.post('/api/trading/networks/setDefault', tradingId,
          { headers: {'Content-Type': 'application/json; charset=UTF-8'} },
      )
    }

    httpDownloadFinalReportFile(taskId: number, file: string) {
      return this.$http.get('/api/task/result-for-revaluation', {
          method: 'GET',
          responseType: 'blob',
          params: {
              taskId
          },
      })
          .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', file.endsWith('.xlsx') ? file : 'final_report.xlsx');
              document.body.appendChild(link);
              link.click();
          })
          .catch((e) => {
              this.showError(i18n.t('http.errors.downloadReport') as string);
          });
    }

    httpSaveGlobalSettings(globalSettingsData: GlobalSettingsData): AxiosPromise<GlobalSettingsData> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.post(`/api/settings/global`, globalSettingsData)
            .catch((err) => {
                this.showError(i18n.t('http.errors.saveParams') as string);
                throw err
            });
    }


    httpSaveOperatingExpensesSettings(params: TradingSettingsData, tradingId: number): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();
        return this.$http.post('/api/settings', params, { params: {tradingId} })
            .catch((err) => {
                this.showError(i18n.t('http.errors.saveOperationalCosts') as string);
                throw err
            });
    }

    httpGetGlobalSettings(): AxiosPromise<GlobalSettingsData> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/settings/global`)
    }

    httpGetTradingSettings(tradingId: number): AxiosPromise<TradingSettingsData> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/settings`, { params: { tradingId } })
    }

    httpGetSalePointsDirectoryErrors(tradingId: number): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get('/api/error/list/sale-points-directory', {
            method: 'GET',
            responseType: 'blob',
            params: {
                tradingId: tradingId,
            },
        }).catch((e) => {
            this.showError(i18n.t('http.errors.getErrorLog') as string);
            throw e
        })
    }

    httpGetSalePointsDirectoryErrorsAmount(tradingId: number): AxiosPromise<number> {
      const auth = localStorage.getItem('AUTH');
      if (!auth) return Promise.reject();

      return this.$http.get(`/api/error/list/sale-points-directory/amount`, { params: { tradingId } })
          .catch((e) => {
              this.showError(i18n.t('http.errors.getErrorCount') as string);
              throw e
          })
    }

    httpGetSalePointsDirectoryFilterOptions(tradingId: number): AxiosPromise<SalePointsDirectoryFilterOptions> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/sale-points-directory/filters`, { params: { tradingId } })
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadFilters') as string);
                throw e
            })
    }

    httpGetFixedPricesFilterOptions(tradingId: number,
                                    regularPriceStartDate?: string,
                                    regularPriceEndDate?: string
    ): AxiosPromise<IHttpGetFixedPricesFilterOptions> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/fixed-prices/filters`, {
            params: {
                tradingId,
                regularPriceStartDate,
                regularPriceEndDate
            }
        })
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadFilters2') as string);
                throw e;
            })
    }

    httpUpdateLastAssortmentBySalePointsDirectory(tradingId: number): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.post(`/api/sale-points-directory/update-last-assortment`,
            null,
            { params: { tradingId } }
        ).catch((e) => {
            let message = !!e.response.status && e.response.status != 500
                ? e.response.data
                : i18n.t('http.errors.updateLastAssortment') as string
            this.showError(message);
            throw e
        })
    }

    httpGetLastAssortmentUpdatingBySalePointsDirectoryStatus(tradingId: number): AxiosPromise<LastAssortmentUpdatingStatus> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/sale-points-directory/update-last-assortment/status`,
            { params: { tradingId } }
        )
            .catch((e) => {
                this.showError(i18n.t('http.errors.getAssortmentUpdateStatus') as string);
                throw e
            })
    }

    httpUpdateLastAssortmentByAssortmentDirectory(tradingId: number): AxiosPromise<string> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.post(`/api/assortment-directory/update-last-assortment`,
            null,
            { params: { tradingId } }
        ).catch((e) => {
            let message = !!e.response.status && e.response.status != 500
                ? e.response.data
                : i18n.t('http.errors.updateLastAssortment2') as string
            this.showError(message);
            throw e
        })
    }

    httpGetLastAssortmentUpdatingByAssortmentDirectoryStatus(tradingId: number): AxiosPromise<LastAssortmentUpdatingStatus> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/assortment-directory/update-last-assortment/status`,
            { params: { tradingId } }
        )
            .catch((e) => {
                this.showError(i18n.t('http.errors.getAssortmentUpdateStatus2') as string);
                throw e
            })
    }

    httpUploadCorrectedPricesFile(
        taskId: number,
        uploadFile: FormData,
        mode: PriceImportMode
    ): AxiosPromise<boolean> {
        return this.$http.put(`/api/task/${taskId}/import-correct-prices-by-file`, uploadFile, {
            headers: { 'content-type': 'multipart/form-data' },
            params: { mode }
        });
    }

    httpUploadFixedPricesFile(
        tradingNetworkId: number,
        uploadFile: FormData
    ): AxiosPromise<any> {
        return this.$http.post('/api/fixed-prices/upload', uploadFile, {
            headers: {'content-type': 'multipart/form-data'},
            params: {tradingId: tradingNetworkId}
        });
    }

    httpGetFixedPrices(
        params: FixedPriceParams
    ): AxiosPromise<{
        content: FixedPriceItem[];
        totalElements: number;
        totalActiveElements?: number;
    }> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        const { user_id: userId } = JSON.parse(auth);

        return this.$http.get(`/api/fixed-prices`, {
            params,
            paramsSerializer: (params) => {
                const result = new URLSearchParams();

                Object.entries(params).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        value.forEach(item => {
                            if (item !== null) {
                                result.append(key, item);
                            }
                        });
                    } else {
                        if (value !== null) {
                            result.append(key, String(value));
                        }
                    }
                });

                return result.toString();
            },
        }).catch((e) => {
            this.showError(i18n.t('http.errors.loadFixedPrices') as string);
            throw e
        });
    }

    httpGetFixedPricesFile(
        params: FixedPriceParams
    ): AxiosPromise<any> {
      debugger
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.post('/api/fixed-prices/export', params, {
            responseType: 'blob'
        }).catch((e) => {
            this.showError(i18n.t('http.errors.exportFixedPricesFile') as string);
            throw e
        })
    }

    httpGetRegionsAndLegalEntities(
        params: IStoreLegalEntityTableParams
    ): AxiosPromise<{
        regionStoreLegalEntities: IStoreLegalEntityTableItem[];
        totalSize: number;
    }> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/sale-points-directory/regions-and-legal-entities`, {params})
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadRegions') as string);
                throw e;
            });
    }

    httpGetLegalOptions(
        params: {tradingId: number}
    ): AxiosPromise<{
        regionOptions: IdAndName[];
        storeLegalEntityOptions: IdAndName[];
    }> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/sale-points-directory/regions-and-legal-entities/options`, {params})
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadFilterOptions') as string);
                throw e;
            });
    }

    httpUploadAssortmentDirectoryFile(
        tradingNetworkId: number,
        uploadFile: FormData
    ): AxiosPromise<any> {
        return this.$http.post('/api/file/upload-assortment-directory-file', uploadFile, {
            headers: {'content-type': 'multipart/form-data'},
            params: {tradingId: tradingNetworkId}
        });
    }

    httpGetAssortmentDirectoryItems(
        params: AssortmentDirectoryParams
    ): AxiosPromise<Page<AssortmentDirectoryItem[]>> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        const { user_id: userId } = JSON.parse(auth);

        return this.$http.post(`/api/assortment-directory`, params).catch((e) => {
            this.showError(i18n.t('http.errors.loadAssortmentDirectory') as string);
            throw e
        });
    }

    httpGetAssortmentDirectoryErrorsAmount(tradingId: number): AxiosPromise<number> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/error/list/assortment-directory/amount`, { params: { tradingId } })
            .catch((e) => {
                this.showError(i18n.t('http.errors.getErrorCount2') as string);
                throw e
            })
    }

    httpGetAssortmentDirectoryFilterOptions(
        tradingId: number,
        params: AssortmentDirectoryFilterOptionsParams
    ): AxiosPromise<AssortmentDirectoryFilterOptions> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.post(`/api/assortment-directory/filters`, params, { params: { tradingId } })
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadFilters3') as string);
                throw e
            })
    }

    httpGetAssortmentDirectoryErrors(tradingId: number): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get('/api/error/list/assortment-directory', {
            method: 'GET',
            responseType: 'blob',
            params: {
                tradingId: tradingId,
            },
        }).catch((e) => {
            this.showError(i18n.t('http.errors.getErrorLog2') as string);
            throw e
        })
    }

    httpGetAssortmentDirectoryFile(
        params: AssortmentDirectoryParams
    ): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.post('/api/assortment-directory/export', params, {
            method: 'GET',
            responseType: 'blob'
        }).catch((e) => {
            this.showError(i18n.t('http.errors.exportAssortmentDirectoryFile') as string);
            throw e
        })
    }

    httpUploadProductLineDirectoryFile(
        tradingNetworkId: number,
        uploadFile: FormData
    ): AxiosPromise<any> {
        return this.$http.post('/api/file/upload-product-line-directory-file', uploadFile, {
            headers: {'content-type': 'multipart/form-data'},
            params: {tradingId: tradingNetworkId}
        });
    }

    httpGetFileUploadUsers(fileType: FileType, tradingId: number): AxiosPromise<UserShortInfo[]> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get('/api/file/upload-users', { params: { type: fileType, tradingId } })
            .catch((e) => {
                this.showError(i18n.t('shared.messages.errorLoadUserList') as string);
                throw e
            })
    }

    httpGetProductLineDirectoryErrorsAmount(tradingId: number): AxiosPromise<number> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get('/api/error/list/product-line-directory/amount', { params: { tradingId } })
            .catch((e) => {
                this.showError(i18n.t('http.errors.getProductLineDirectoryErrorsAmount') as string);
                throw e
            })
    }

    httpGetProductLineDirectoryErrors(tradingId: number): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get('/api/error/list/product-line-directory', {
            method: 'GET',
            responseType: 'blob',
            params: {
                tradingId: tradingId,
            },
        }).catch((e) => {
            this.showError(i18n.t('http.errors.getProductLineDirectoryErrors') as string);
            throw e
        })
    }

    httpGetFileErrorsById(fileId: number): AxiosPromise<Blob> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get('/api/error/list', {
            responseType: 'blob',
            params: { fileId },
        });
    }

    httpExportProductLineDirectory(tradingId: number): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.post('/api/product-line-directory/export', null, {
            responseType: 'blob',
            params: { tradingId }
        }).catch((e) => {
            this.showError(i18n.t('http.errors.exportProductLineDirectoryFile') as string);
            throw e
        })
    }

    httpSyncProductLinesToAssortment(tradingId: number): AxiosPromise<string> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.post('/api/product-line-directory/sync-to-assortment', null, {
            params: { tradingId }
        }).catch((e) => {
            const status = e.response && e.response.status;
            if (status === 400) {
                this.showError(i18n.t('masterData.productLine.optionDisabled') as string);
            } else if (status === 409) {
                this.showError(i18n.t('masterData.productLine.syncAlreadyRunning') as string);
            } else {
                this.showError(i18n.t('http.errors.syncProductLines') as string);
            }
            throw e
        })
    }

    httpGetSyncProductLinesStatus(tradingId: number): AxiosPromise<DirectoriesSynchronizationStatus> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get('/api/product-line-directory/sync-to-assortment/status', {
            params: { tradingId }
        }).catch((e) => {
            this.showError(i18n.t('http.errors.getSyncProductLinesStatus') as string);
            throw e
        })
    }

    httpGetCartProductsTableFilterOptions(
        tradingId: number,
        kviCartId: number,
        filters: CartProductsTableFilterOptionsPayloadFilters,
    ): AxiosPromise<AssortmentDirectoryFilterOptions> {
        return this.$http.post('/api/assortment/carts/options', filters, { params: { tradingId, kviCartId } })
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadCartProductTableFilters') as string);

                throw e;
            });
    }

    httpProductLineRecommendationSearchStart(
        request: ProductLineRecommendationSearchParams
    ): AxiosPromise<any> {
        return this.$http.post('/api/product-line/recommendations/start', request, {
            method: 'POST',
            responseType: 'blob',
            timeout: 0, // долгие запросы (до 30 мин)
        })
            .catch((e) => {
                this.showError(i18n.t('http.errors.startProductRangeSearch') as string);
                throw e
            })
    }

    httpUpdateActiveStatus(
        params: UpdateActiveStatusParams
    ) {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        const { user_id: userId } = JSON.parse(auth);

        return this.$http.post(`/api/fixed-prices/update-active-status`, params).catch((e) => {
            this.showError(i18n.t('http.errors.updateStatus') as string);
            throw e
        });
    }

    httpCalcBySelectedSKUs(
        params: CalcBySelectedSKUsParams
    ) {
         return this.$http.post('/api/task/package/fixed-prices', params).catch((e) => {
            this.showError(i18n.t('http.errors.startCalculation') as string);
            throw e;
        });
    }

    httpCalcEndedFixedPriceSKUs() {
        return this.$http.post('/api/task/package/ended-fixed-prices').catch((e) => {
            this.showError(i18n.t('http.errors.startCalculation2') as string);
            throw e;
        });
    }

    httpApproveReportDetailLines(
        taskId: number,
        selectedCheckboxesData: ApproveReportElementsSelectedCheckboxesData,
    ) {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        const { user_id: userId } = JSON.parse(auth);

        return this.$http.post(`/api/task/tableDetailReports/${taskId}/approve`, selectedCheckboxesData, {
            params: { userId },
        })
            .catch((e) => {
                this.showError(i18n.t('http.errors.approveReportPositions') as string);

                throw e;
            });
    }

    httpFetchCompetitorsList(tradingId: number, pagination: {current: number, pageSize: number}, withCluster: boolean = true): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`api/competitors-directory/keys/${tradingId}`, {
            params: {
                page: pagination.current - 1,
                size: pagination.pageSize,
                withCluster,
            }
        })
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadCompetitors') as string);
                throw e;
            });
    }

    httpFetchCompetitorLinkedProducts(params: IPaginationAndSortingData, payload: any): AxiosPromise<{
        content: ICompetitorProduct[],
        totalElements: number,
    }> {
        return this.$http.post(`/api/parsing/product-links/search`, payload, { params })
            .catch((e) => {
                this.showError(i18n.t('http.errors.getCompetitorProducts') as string);
                throw e;
            });
    }

    httpLinkProductsToCompetitor(body: any) {
        return this.$http.post(`/api/parsing/product-links/competitor-products`, body)
            .catch((e) => {
                this.showError(i18n.t('http.errors.linkProductsToCompetitor') as string);
                throw e;
            });
    }

    httpFetchCompetitorLinkedProductsTableOptions(params: any): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/parsing/product-links/filter-options`, {
            params,
            paramsSerializer: (queryParams) => {
                const result = new URLSearchParams();

                Object.entries(queryParams).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        value.forEach((item) => {
                            if (item !== null && item !== undefined) {
                                result.append(key, String(item));
                            }
                        });
                    } else if (value !== null && value !== undefined) {
                        result.append(key, String(value));
                    }
                });

                return result.toString();
            },
        })
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadFilteringOptions') as string);
                throw e;
            });
    }

    httpFetchParsingResults(filter: any, config: any): AxiosPromise<Page<ParsingResultTableItem[]>> {
        return this.$http.post('/api/parsing/results/search', filter, config)
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadParsingResults') as string);
                throw e;
            });
    }

    httpGetParsingResultsFile(params: any): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return this.$http.post('/api/parsing/results/export', params, {
            responseType: 'blob',
            headers: {
                'X-Timezone': timezone
            }
        }).catch((e) => {
            this.showError(i18n.t('http.errors.exportParsingResultsFile') as string);
            throw e
        })
    }

    httpApplyParsingResults(data: ICheckboxesStateWithFilter<FetchResultsFilterParams>): AxiosPromise<Page<any[]>> {
        return this.$http.post('/api/parsing/results/apply', data)
            .catch((e) => {
                this.showError(i18n.t('http.errors.applyParsingResults') as string);
                throw e;
            });
    }

    httpFetchParsingResultsTableOptions(tradingId: number): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/parsing/results/filter-options`, { params: { tradingId } })
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadFilteringOptions2') as string);
                throw e;
            });
    }

    httpStartPriceAudit(data: StartPriceAuditRequest): AxiosPromise<any> {
        return this.$http.post('/api/parsing/audit', data)
            .catch((e) => {
                throw e;
            });
    }

    httpDeleteParsingResults(data: ICheckboxesStateWithFilter<FetchResultsFilterParams>): AxiosPromise<any> {
        return this.$http.post('/api/parsing/results/delete', data)
            .catch((e) => {
                this.showError(i18n.t('http.errors.deleteParsingResults') as string);

                throw e;
            });
    }

    httpUploadMonitoringFile(tradingId: number, uploadFile: FormData): AxiosPromise<any> {
        return this.$http.post('/api/parsing/results/upload', uploadFile, {
            headers: {'content-type': 'multipart/form-data'},
            params: {tradingId}
        });
    }

    httpGetMonitoringErrorsAmount(tradingId: number): AxiosPromise<number> {
        return this.$http.get(`/api/error/list/parsing/results/amount`, { params: { tradingId } })
            .catch((e) => {
                this.showError(i18n.t('http.errors.getErrorCount3') as string);

                throw e;
            })
    }

    httpGetMonitoringErrors(tradingId: number): AxiosPromise<any> {
        return this.$http.get('/api/error/list/parsing/results', {
            method: 'GET',
            responseType: 'blob',
            params: {
                tradingId: tradingId,
            },
        }).catch((e) => {
            this.showError(i18n.t('http.errors.downloadErrorsFile') as string);

            throw e;
        })
    }

    httpUploadCompetitorProductLinksFile(tradingId: number, uploadFile: FormData): AxiosPromise<any> {
        return this.$http.post('/api/parsing/product-links/upload', uploadFile, {
            headers: {'content-type': 'multipart/form-data'},
            params: {tradingId}
        });
    }

    httpGetCompetitorProductLinksErrorsAmount(tradingId: number): AxiosPromise<number> {
        return this.$http.get(`/api/error/list/competitor-product-link/results/amount`, { params: { tradingId } })
            .catch((e) => {
                this.showError(i18n.t('http.errors.getErrorCount4') as string);

                throw e;
            })
    }

    httpGetCompetitorProductLinksErrors(tradingId: number): AxiosPromise<any> {
        return this.$http.get('/api/error/list/competitor-product-link/results', {
            method: 'GET',
            responseType: 'blob',
            params: {
                tradingId: tradingId,
            },
        }).catch((e) => {
            this.showError(i18n.t('http.errors.downloadErrorsFile2') as string);

            throw e;
        })
    }

    httpGetAuditProcessStatus(tradingId: number): AxiosPromise<'DONE' | 'FAILED' | 'IN_PROGRESS'> {
        return this.$http.get(`/api/parsing/audit/status`, { params: { tradingId } })
            .catch((e) => {
                this.showError(i18n.t('http.errors.getAuditStatus') as string);

                throw e;
            })
    }

    httpFetchParsingConfigs(filter: any, params: any): AxiosPromise<Page<any[]>> {
        return this.$http.post('/api/parsing/configs/search', filter, { params })
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadParsingSettings') as string);
                throw e;
            });
    }

    httpFetchParsingConfigsTableOptions(tradingId: number): AxiosPromise<any> {
        const auth = localStorage.getItem('AUTH');
        if (!auth) return Promise.reject();

        return this.$http.get(`/api/parsing/configs/filter-options`, { params: { tradingId } })
            .catch((e) => {
                this.showError(i18n.t('http.errors.loadFilteringOptions3') as string);
                throw e;
            });
    }

    httpUpdateCompetitorProductLink(id: number, parsingUrl: string | null): AxiosPromise<any> {
        return this.$http.patch(`/api/parsing/product-links/${id}`, { parsingUrl })
            .catch((e) => {
                this.showError(i18n.t('http.errors.updateLink') as string);
                throw  e
            });
    }

    httpCreateParser(data: any) {
        return this.$http.post('/api/parsing/configs', data)
            .catch((e) => {
                this.showParserConfigError(e, 'http.errors.addParser');
                throw e;
            });
    }

    httpUpdateParserSettings(id: number, data: any) {
        return this.$http.patch(`/api/parsing/configs/${id}`, data)
            .catch((e) => {
                this.showParserConfigError(e, 'http.errors.updateParserSettings');
                throw e;
            });
    }

    httpPutParserSettings(id: number, data: any) {
        return this.$http.put(`/api/parsing/configs/${id}`, data)
            .catch((e) => {
                this.showParserConfigError(e, 'http.errors.updateParserSettings');
                throw e;
            });
    }

    private showParserConfigError(e: any, fallbackKey: string) {
        const responseData = e.response && e.response.data;

        if (e.response && e.response.status === 400 && typeof responseData === 'string' && responseData.trim()) {
            this.showError(responseData);
            return;
        }

        this.showError(i18n.t(fallbackKey) as string);
    }

    httpDownloadParserErrors(id: number) {
        return this.$http.get(`/api/parsing/errors/download/${id}`, {
            method: 'GET',
            responseType: 'blob',
            params: {},
        })
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'parsing-errors.txt');
                document.body.appendChild(link);
                link.click();
            }).catch(() => {
                this.showError(i18n.t('http.errors.getParsingErrors') as string);
            });
    }

    httpDeleteParser(id: number): AxiosPromise<any> {
        return this.$http.delete(`/api/parsing/configs/${id}`)
    }

    httpUnlinkCompetitorProducts(data: ICheckboxesStateWithFilter<IHttpUnlinkCompetitorProductsFilter>): AxiosPromise<any> {
        return this.$http.post(`/api/parsing/product-links/delete`, data);
    }

    httpStartAutomaticCompetitorsSelection(data: any): AxiosPromise<any> {
        return this.$http.post(`/api/parsing/competitor-products-search`, data);
    }

    httpFetchCompetitorsSelectionData(ids: any): AxiosPromise<any> {
        return this.$http.post('/api/parsing/competitor-products-search/tasks', ids);
    }

    httpFetchCompetitorDomains(): AxiosPromise<string[]> {
        return this.$http.get('/api/parsing/competitor-products-search/domains');
    }

    httpSaveKviRulesParams(params: KviRoundingParams) {
        return this.$http.post('/api/rounding/kvi/save-rules-params', params)
    }

    httpFindKviRulesParams(findParams: KviRoundingFindParams): AxiosPromise<KviRoundingParams> {
        return this.$http.post('/api/rounding/kvi/find-params', findParams)
    }

    httpUploadKviRoundingRule(uploadFile: FormData, uploadProgress: (e: any) => void): AxiosPromise<any> {
        return this.$http.post('/api/rounding/kvi/upload-rounding-rule', uploadFile, {
            headers: {
                'content-type': 'multipart/form-data',
            },
            onUploadProgress: uploadProgress,
        });
    }

    httpLoadKviRoundingRules(filter: KviRoundingRulesFilter, lim: number, off: number): AxiosPromise<Page<BaseFilterRoundingTable[]>> {
        return this.$http.post('/api/rounding/load-kvi', filter, {
            params: {
                limit: lim,
                offset: off,
            },
        });
    }

    httpDeleteKviRoundingRulesFile(id: number) {
        return this.$http.delete('/api/rounding/kvi/deleteFile', {params: {ruleId: id}})
    }

    httpCreateExportTask(data: any) {
        return this.$http.post('/api/export', data)
            .catch((e) => {
                this.showError(i18n.t('http.errors.startExport') as string);

                throw e;
            });
    }

    httpFetchExportTaskList(params: any): AxiosPromise<Page<IExportTask[]>> {
        return this.$http.get('/api/export/tasks', {params})
            .catch((e) => {
                this.showError(i18n.t('http.errors.getExportTasks') as string);
                throw e;
            });
    }

    httpGetTokenForDownloadExportFile(taskId: number): AxiosPromise<ITokenForDownloadExportFile> {
        return this.$http.get(`/api/export/download-token/${taskId}`)
            .catch((e) => {
                this.showError(i18n.t('http.errors.getDownloadToken') as string);

                throw e;
            });
    }

    httpDeleteExportTask(taskId: number): AxiosPromise<any> {
        return this.$http.delete(`/api/export/${taskId}`);
    }

    httpCancelExportTask(taskId: number): AxiosPromise<any> {
        return this.$http.post(`/api/export/cancel/${taskId}`)
            .catch((e) => {
                this.showError(i18n.t('http.errors.cancelExport') as string);

                throw e;
            });
    }

    httpSendAiAssistantMessage(messageData: FormData): AxiosPromise<any> {
        return this.$http.post('/api/assistant/chat', messageData);
    }

    httpGetAiAssistantMessages(threadId: string): AxiosPromise<any> {
        // return this.$http.get(`/api/assistant/messages/${threadId}`);

        return Promise.resolve({
            data: {
                success: true,
            },
            status: 200,
            statusText: 'OK',
            headers: {},
            config: {},
            request: {}
        });
    }

    httpUploadOmnichannelStrategiesFile(
        tradingId: number,
        uploadFile: FormData,
        uploadOption: ImportUploadOption
    ): AxiosPromise<string> {
        return this.$http.post('/api/omnichannel-strategies/upload-omnichannel-strategies-file', uploadFile, {
            headers: { 'content-type': 'multipart/form-data' },
            params: { tradingId, uploadOption },
        });
    }

    httpGetLastFileErrorsAmount(tradingId: number, fileType: string): AxiosPromise<number> {
        return this.$http.get('/api/error/list/files/last/amount', {
            params: { tradingId, fileType },
        }).catch((e) => {
            this.showError(this.$t('omnichannelStrategy.messages.getErrorsAmountFailed') as string);
            throw e;
        });
    }

    httpGetOmnichannelStrategiesImportErrors(tradingId: number): AxiosPromise<any> {
        return this.$http.get('/api/error/list/omnichannel-strategies-import', {
            params: { tradingId },
        }).catch((e) => {
            this.showError(this.$t('omnichannelStrategy.messages.getErrorLogFailed') as string);
            throw e;
        });
    }

    httpExportOmnichannelStrategies(tradingId: number, userId: number): AxiosPromise<Blob> {
        return this.$http.get('/api/omnichannel-strategies/export', {
            params: { tradingId, userId },
            responseType: 'blob',
        }).catch((e) => {
            this.showError(this.$t('omnichannelStrategy.messages.exportFailed') as string);
            throw e;
        });
    }

    httpGetOmnichannelStrategiesUploadStatus(tradingId: number): AxiosPromise<IUpdateOmnichannelStrategiesTask> {
        return this.$http.get('/api/omnichannel-strategies/upload-status', { params: { tradingId } })
            .catch((e) => {
                this.showError(this.$t('omnichannelStrategy.messages.uploadStatusFailed') as string);
                throw e;
            });
    }
}
